import { makeAutoObservable } from "mobx";
import apiClient, { plainApiClient } from "../api";
import { uploadProfileHook } from "../api/hooks/Auth";
import {
  getClientCorporateActions,
  getClientPortfolio,
  getClientPortfolioAssetClass,
  getClientPortfolioReturn,
  getClientRecentTransaction,
  getFamiliesPortfolioAssetClasses,
  getFamilyCorporateActions,
  getFamilyPortfolio,
  getFamilyPortfolioReturn,
  getFamilyRecentTransaction,
  getLinkedClients,
  pointOfConnect,
  postFeedback,
  getFamilyPortfolioReturnInfinity,
  getClientPortfolioReturnInfinity,
  getReturnsLine,
  getQuickViews,
  liaisonDetails,
  infinityReturns,
  vehicleDetails,
  getInfinityData,
  quickView,
  usersTransaction,
  getUserTaxLots,
  getFamilyView,
  getNavigationData,
  getAnalyticsNavigationData,
  getUsersPortfolioReturn,
  getUsersPortfolio,
  getUsersPortfolioAssetClasses,
  getUsersSubAssetClasses,
  getUsersReturnsLine,
  getUsersFamilyView,
  getUsersCurrency,
  getPortfolioReturn,
  getPortfolio,
  getUsersRealEstateData,
  getUsersDerivativesData,
  getUsersPortfolioDerivativesData,
  getUsersLiabilitieslas,
  getUsersLiabilities,
  getUsersInstrumentReturns,
  getUsersTransactions,
  getUsersInvestmentDetailsOffshore,
  getSecondaryRm,
} from "../api/hooks/user";
import {
  arrangeSnippets,
  dataIsArray,
  getAssetClasses,
  getAssetsClassTabsData,
  getBlobToBase64,
  getDecodedToken,
  getExcelNumData2,
  getFileSize,
  getLas,
  getLimitPer,
  getOffshoreInvestmentReturn,
  getOffshoreSubAssetDataStructure,
  getSubAssetClasses,
  getSubAssetTabs,
  getUniqueCurrencies,
  getUserDataForAPIs,
  lakhAmt,
  returnModifiedData,
  updateCurrencyData,
} from "../utils/functions";
import {
  allUsersSetting,
  deafaultOffshoreApiStatus,
  defaultOffshoreSubAssetApiStatus,
  MANAGER,
  NON_PRIMARY_CUSTOMER,
  OFFSHORE_SUB_ASSET_PAGE,
  pendingOffshoreSubAssetApiStatus,
  homePageRoute,
  settingsMenuDetails,
  snippetDefaultData,
  defaultSecondaryRMData,
} from "../utils/constants";
import { isHydrated } from "mobx-persist-store";
import AuthStore from "./AuthStore";
import SettingsStore from "./SettingsStore";
import ProfileStore2 from "./ProfileStore2";
import PerformanceStore from "./PerformanceStore";
import ReportsStore from "./ReportsStore";
import { makePersistable } from "mobx-persist-store";
import { setCookie, getCookie } from "../utils/cookie";
import { customStorage } from "../utils/customStorage";
import { familyMembers } from "../api/hooks/profile";

class UserStore {
  subAssetClassName = null;
  asOfDate = null;
  unrealisedData = null;
  infinityData = null;
  homeRecentTransactionLength = null;
  isSalesForceLogin = false;
  isUserLoggedIn = false;
  isNoDataSubAssetLevel = false;
  isNoAssetClassPresent = false;
  employeeFamilies = null;
  rememberedFamilyData = [];
  showFamilyData = [];
  sessionId = undefined;
  linkedClients = undefined;
  usersFamilyName = "";
  userData = { allMembers: true };
  data = "";
  userDeviceId = "";
  portfolio = {};
  tabsClicked = undefined;
  familyId = "";
  userId = "";
  getData = "fam";
  connectData = [];
  rememberedMeasureId = "";
  selectedContact = undefined;
  withNuvama = getCookie("withNuvama") === "1";
  withOthers = getCookie("withOthers") === "1";
  withNuvamaState = getCookie("withNuvamaState") === "1";
  withOthersState = getCookie("withOthersState") === "1";
  useNuvamaFilter = getCookie("usernuvamafilter") === "1";
  loggedInWithOthers = undefined;
  vehicleInstrumentData = {};
  getDataWithNuvamaOrOther = "";
  getDataWithNuvamaOrOtherState = "";
  currentFamilyMembers = undefined;
  currentFamilyMembersImages = null;
  realEstateImage = null;
  selectedInstrumentVehicle = { vehicleId: null, assetClassId: null };
  instrumentDetails = undefined;
  constUserId = this.userData?.user_id || getCookie("userid");
  constFamilyId = this.userData?.family_id || getCookie("famid");
  quickViewDetails = undefined;
  derivativesDetails = [];
  realEstateData = undefined;
  isInfinity = "0";
  portfolioPath = [];
  analyticsPath = [];
  isPrimary = true;
  isLive = "0";
  singleUsersUrl = "";
  liaisonImage = "";
  isNavigated = false;
  toggleLive = false;
  connectImages = {};
  selectedMemberIsPrimary = true;
  infinityMesurementId = "";
  forThirdLevelMeasureId = "";
  infinityPortfolioReturns = undefined;
  excelAssetClassesData = undefined;
  excelAssetClassesDataInfinity = undefined;
  excelAssetDataFamily = undefined;
  exportDetails = undefined;
  selectedClientId = "0";
  homeLoad = false;
  selectedPortfoliotab = "financial";
  selectedAnalyticsTab = "Overall";
  clientQuickviews = null;
  isHybridNormalInstrument = false;
  infinityHoldingData = null;
  nonInfinitySubAssetData = null;
  isSelectedUserPrimary = null;
  selectedRefIdInfinity = "";
  selectedRefIdSub = "";
  selectedRefId = "";
  forReportsInceptionDate = null;
  transectionReportFilter = {
    timePeriod: "current_month",
    transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
    upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
    selectedMember: "All",
    selectedAssetClass: "All",
    selectedAccount: "All",
    selectedAcquisitionDate: "",
  };
  portfolioReportFilter = {
    timePeriod: "current_month",
    denomination: {},
    selectedMember: "All",
    selectedAccount: "All",
    selectedAcquisitionDate: "Transfer-In Date",
    selectedSection: [1, 3],
  };
  transectionCorporateActionReportFilter = {
    timePeriod: "current_fy",
    transectionType: "interest",
    selectedMember: "All",
    selectedAssetClass: "All",
  };
  selectedUsersId = null;
  othersInfinityHolding = {
    clientcode: "1",
    id: 100,
    assetClass: {
      clientcode: "1",
      id: 0,
      name: "Others",
      defaultIndex: {
        clientcode: "",
        id: 0,
        name: "",
      },
    },
    allocation_percentage: "0",
    investmentreturn: {
      clientcode: "1",
      as_of_date: "",
      current_value: {
        actual_value: "",
        value: "",
        value_type: "",
      },
      total_returns: {
        actual_value: "",
        value: "",
        value_type: "",
      },
      irr: "0.00",
      invested_value: {
        actual_value: "",
        value: "",
        value_type: "",
      },
      int_div: {
        amount: {
          actual_value: "",
          value: "",
          value_type: "",
        },
        percentage: "",
      },
      unrealised_gain: {
        amount: {
          actual_value: "",
          value: "",
          value_type: "",
        },
        percentage: "",
      },
      realised_Gains: {
        amount: {
          actual_value: "",
          value: "",
          value_type: "",
        },
        percentage: "",
      },
      measureinstrumentid: "",
      commitment_val: "",
      maturity_Date: "",
    },
    instrumentVehiclesList: [],
  };
  fromPortfolio = false;
  fromHome = false;

  fromPerformance = false;
  lstInstrumentReturnsFromHome = [];
  totalCurrentValueFromHome = {
    actual_value: "",
    value: "",
    value_type: "",
  };
  portfolioReportFileName = "";
  portfolioReportObj = {};
  selectedAccount = {};
  taxFromDate = {};
  taxToDate = {};
  taxPdfDownloadFromDate = "";
  taxPdfDownloadToDate = "";
  emailIdDataForTax = {};
  isTaxSendEmail = "";
  selectedUserForEmail = "";
  selectedUserForName = "";

  modifiedData = [];
  modifiedInfinityData = [];
  rememberedInfinityData = [];
  rememberedModifiedData = [];
  reportsFirstState = "";
  selectedInstrumentVehicleInfinity = undefined;
  taxReportDownloadError = false;
  portfolioReportDownloadError = false;
  portfolioOpenID = null;
  infinityOpenID = null;
  portfolioTabsStatus = {
    financial: false,
    liabilities: false,
    derivatives: false,
    realEstate: false,
    offshore: false,
  };
  liabilitieslasStatus = null;
  liabilitiesStatus = null;
  financialApiStatus = {
    QuickViews: null,
    familyPortfolioReturn: null,
    familyPortfolio: null,
    assetClass: null,
    subAssetClass: null,
    returnsLine: null,
  };
  offshoreApiStatus = {};
  offshoreTabApiStatus = {};
  memberChangeOffshoreApiStatus = {};
  HomePageApiStatus = {
    connectApi: null,
    familyPortfolio: null,
    familyPortfolioReturn: null,
    familyRecentTransaction: null,
    familyCorporateActions: null,
    familyMemberAccessData: null,
    profileData: null,
  };

  subAssetStatus = null;

  subAssettabs = [];
  assetdData = [];
  callingSubAssetApi = false;
  callingLiveApi = {
    tileDataLoading: false,
    tableDataLoading: false,
  };

  selectedInfinityInstrument = {
    assetClassId: null,
    vehicleId: null,
  };

  subAssetFirstVehicleListIds = {
    assetId: null,
    subAssetId: null,
  };

  isInfinityPopulated = false;
  familyViewData = [];
  portfolioLoader = {
    portfolioMainLoader: "default",
    portfolioSubLoader: "default",
    infinitySubLoader: "default",
    infinityMainLoader: "default",
    quickViewInfinity: "default",
  };

  snippets = { ...snippetDefaultData };

  vehicleDataLength = null;
  usersData = "";

  currencyData = [];
  offshoreData = {};
  selectedOffshoreInstrument = { vehicleId: null, assetClassId: null };
  updatedOffshoreInstruments = [];
  subAssetCurrencyData = [];
  offshoreInstrumentTransactions = {};

  isOffshoreAssetPageLoading = false;
  isOffshoreAssetTabLoading = false;
  isOffshoreAssetDataLoading = false;
  isFullPageLoaderOffshoreSubAsset = false;
  isAssetClassTabLoading = false;
  isCurrencyDataLoading = false;
  isInstrumentsDataLoading = false;

  offshoreSubAssetApiFetchStatus = defaultOffshoreSubAssetApiStatus;
  selectedCurrency = {
    currency: "",
  };
  offshoreSubAssetPageTabs = [];
  secondaryRMDetails = defaultSecondaryRMData;

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "User",
      properties: [
        "usersData",
        "asOfDate",
        "infinityData",
        "loggedInWithOthers",
        "unrealisedData",
        "homeRecentTransactionLength",
        "isSalesForceLogin",
        "employeeFamilies",
        "sessionId",
        "linkedClients",
        "userData",
        "data",
        "singleUsersUrl",
        "liaisonImage",
        "taxFromDate",
        "taxToDate",
        "taxPdfDownloadFromDate",
        "taxPdfDownloadToDate",
        "emailIdDataForTax",
        "isTaxSendEmail",
        "selectedUserForEmail",
        "selectedUserForName",
        "familyId",
        "userId",
        "getData",

        "userDeviceId",
        "connectData",
        "selectedContact",
        "withNuvama",
        "withOthers",
        "transectionReportFilter",
        "portfolioReportFilter",
        "transectionCorporateActionReportFilter",
        "withNuvamaState",
        "withOthersState",
        "getDataWithNuvamaOrOther",
        "currentFamilyMembers",
        "currentFamilyMembersImages",
        "isInfinity",
        "portfolioPath",
        "analyticsPath",
        "isPrimary",
        "isLive",
        "toggleLive",
        "connectImages",
        "selectedMemberIsPrimary",
        "infinityPortfolioReturns", //
        "exportDetails",
        "selectedClientId",
        "selectedAccount",
        "portfolioReportObj",
        "portfolioReportFileName",
        "selectedPortfoliotab", //
        "selectedAnalyticsTab", //
        "isHybridNormalInstrument",
        "nonInfinitySubAssetData", //
        "isSelectedUserPrimary",
        "forReportsInceptionDate",
        "selectedRefId",
        "selectedRefIdInfinity",
        "selectedRefIdSub",
        "selectedUsersId",
        "fromPerformance", //
      ],
      storage: customStorage,
      expireIn: 86400000, // One day in milliseconds
      removeOnExpiration: true,
      stringify: false,
    });
  }

  setIsInfinityPopulated(value) {
    this.isInfinityPopulated = value;
  }

  setAssetTabsData(data, isMap) {
    if (!isMap) this.assetdData = data;
    else {
      this.assetdData = getSubAssetTabs({ data });
    }
  }

  setPortfolioTabsStatusDefault() {
    this.portfolioTabsStatus = {
      financial: false,
      liabilities: false,
      derivatives: false,
      realEstate: false,
      offshore: false,
    };
  }

  setCallingSubAssetApi(data) {
    this.callingSubAssetApi = data;
  }

  setCallingLiveApi(data) {
    this.callingLiveApi = {
      ...data,
    };
  }

  callApisForTabs(tabName, signal) {
    if (tabName === "realEstate" && !this.portfolioTabsStatus[tabName]) {
      this.getRealEstateData({ signal });
    } else if (tabName === "derivatives" && !this.portfolioTabsStatus[tabName])
      this.getDerivative({ signal });
    else if (tabName === "liabilities" && !this.portfolioTabsStatus[tabName]) {
      this.getLiabilitieslas({ signal });
      this.getLiabilities({ signal });
    } else if (tabName === "financial" && !this.portfolioTabsStatus[tabName]) {
      this.populatePortfolio(
        { isScroll: false, measureId: undefined, signal },
        false,
      );
      this.getQuickViews({ signal });
    } else if (tabName === "global" && !this.portfolioTabsStatus[tabName]) {
      this.getOffshoreDataOnFamilyMemberChange({
        isScroll: false,
        signal,
      });
    } else {
      setTimeout(() => {
        PerformanceStore.loaderCloseOnFail();
      }, 10);
    }
  }

  setPortfolioObj(data) {
    this.portfolio = data;
  }

  setOpenId(type, value) {
    this[type] = value;
  }

  setPortfolioLoader(type, value) {
    this.portfolioLoader[type] = value;
  }

  setTaxReportDownloadError(val) {
    this.taxReportDownloadError = val;
  }

  setPortfolioReportDownloadError(val) {
    this.portfolioReportDownloadError = val;
  }

  setIsUserLoggedIn(data) {
    this.isUserLoggedIn = data;
  }

  setSubAssetName(name) {
    this.subAssetClassName = name;
  }

  setPathFrom(data, value) {
    this[data] = value;
  }

  upDateData(data, value) {
    this[data] = value;
  }

  setUserStoreData(data, value) {
    this[data] = value;
  }

  updateUserStoreData(data, value) {
    this[data] = {
      ...this[data],
      ...value,
    };
  }

  setInfinityData(data) {
    this.infinityHoldingData = data;
  }

  setNormalHybirdFlow(data) {
    this.isHybridNormalInstrument = data;
  }

  setTabsClicked() {
    this.tabsClicked = undefined;
  }

  setSelectedTab(tabData) {
    this.selectedPortfoliotab = tabData;
    if (tabData === "financial") this.tabsClicked = true;
  }
  setSelectedAnalyticsTab(tabData) {
    this.selectedAnalyticsTab = tabData;
  }

  setSelectedMemberIsPrimary(data) {
    this.selectedMemberIsPrimary = data;
  }

  setAsOfDate(data, unrealisedData) {
    this.asOfDate = data;
    this.unrealisedData = unrealisedData;
  }
  setInfinityDataReport(data) {
    this.infinityData = data;
  }
  setHomeNoDataCondition(data) {
    this.homeRecentTransactionLength = data.length;
  }

  getCorouselData() {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    const data =
      this.getData === "fam"
        ? { id: familyId, type: "familyid" }
        : { id: userId, type: "userid" };

    let snippetData = {
      performanceSnippets: [],
      analyticsSnippets: [],
      combinedSnippets: [],
    };

    this.upDateData("snippets", {
      data: [],
      performanceStatus: {
        isFetching: true,
        isError: false,
      },
      analyticsStatus: { isFetching: true, isError: false },
    });

    getNavigationData({ ...data })
      .then((response) => {
        const { snippetAssets, snippetOveralls } = response.data;
        let isDisplayIrr = false;
        if (snippetOveralls.length)
          snippetData.performanceSnippets = snippetOveralls?.map(
            (data, idx) => {
              isDisplayIrr = (idx + 1) % 2 === 0;
              return {
                ...data,
                assetClassId: "all",
                isDisplayIrr,
                page: "Performance",
                to: `/performance/overall performance`,
              };
            },
          );
        if (snippetAssets.length) {
          isDisplayIrr = !isDisplayIrr;
          const assets = snippetAssets.reduce((acc, curr) => {
            const currentObj = { ...curr };
            delete currentObj.snippetSubAssets;
            acc.push({
              ...currentObj,
              isDisplayIrr,
              page: "Performance",
              to: `/performance/overall performance`,
            });
            const changedSubAssets = curr.snippetSubAssets?.map((subAsset) => {
              isDisplayIrr = !isDisplayIrr;
              return {
                ...subAsset,
                //parentSnippet: { ...currentObj },
                isDisplayIrr,
                parentSection: curr.section,
                page: "Performance",
                to: `/performance/overall performance/${subAsset.assetClassId}_${subAsset.subAssetClassId}`,
              };
            });
            isDisplayIrr = !isDisplayIrr;
            return [...acc, ...changedSubAssets];
          }, []);
          snippetData.performanceSnippets = [
            ...snippetData.performanceSnippets,
            ...assets,
          ];
        }
        const { analyticsSnippets } = snippetData;
        if (snippetData.analyticsSnippets.length)
          snippetData.combinedSnippets = arrangeSnippets({
            performanceArr: snippetData.performanceSnippets,
            analyticsArr: analyticsSnippets,
          });

        const combined = snippetData.combinedSnippets;
        if (combined.length) {
          this.upDateData("snippets", {
            ...this.snippets,
            data: [...combined],
            performanceStatus: {
              isFetching: false,
              isError: false,
            },
          });
          PerformanceStore.setLoaderStatus("carousalStatus", "success");
          PerformanceStore.loaderCloseFunction();
        }
      })
      .catch((error) => {
        this.upDateData("snippets", {
          ...this.snippets,
          performanceStatus: {
            isFetching: false,
            isError: true,
          },
        });
        PerformanceStore.setLoaderStatus("carousalStatus", "failure");
        PerformanceStore.loaderCloseOnFail();
      });
    getAnalyticsNavigationData({ ...data })
      .then((response) => {
        const { snippetAssets, snippetOveralls } = response.data;

        if (snippetOveralls.length)
          snippetData.analyticsSnippets = snippetOveralls?.map((data) => {
            return {
              ...data,
              page: "Analytics",
              to: `/analytics`,
            };
          });
        if (snippetAssets.length) {
          const assets = snippetAssets?.map((assets) => {
            return {
              ...assets,
              page: "Analytics",
              to: `/analytics`,
            };
          });

          snippetData.analyticsSnippets = [
            ...snippetData.analyticsSnippets,
            ...assets,
          ];
        }

        const { performanceSnippets } = snippetData;
        if (snippetData.performanceSnippets.length)
          snippetData.combinedSnippets = arrangeSnippets({
            performanceArr: performanceSnippets,
            analyticsArr: snippetData.analyticsSnippets,
          });

        const combined = snippetData.combinedSnippets;
        if (combined.length) {
          this.upDateData("snippets", {
            ...this.snippets,
            data: [...combined],
            analyticsStatus: {
              isFetching: false,
              isError: false,
            },
          });
          PerformanceStore.setLoaderStatus("carousalStatus", "success");
          PerformanceStore.loaderCloseFunction();
        }
      })
      .catch((error) => {
        this.upDateData("snippets", {
          ...this.snippets,
          analyticsStatus: {
            isFetching: false,
            isError: true,
          },
        });
        PerformanceStore.setLoaderStatus("carousalStatus", "failure");
        PerformanceStore.loaderCloseOnFail();
      });
  }

  getInfinityReturns(measureId, signal) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    if (this.getData === "fam") {
      PerformanceStore.setLoaderStatus("infinityReturns", "pending");
      // apiClient
      //   .get(
      //     `families/${familyId}/InfinityData?advisor=${this.getDataWithNuvamaOrOther}`
      //   )
      infinityReturns({
        id: familyId,
        advisor: this.getDataWithNuvamaOrOther,
        isFamily: "families",
        signal,
      })
        .then(({ data }) => {
          const currentObj = data?.lstInstrumentReturns?.find(
            (eachData) => eachData.measureinstrumentid === measureId,
          );
          this.infinityHoldingData = currentObj;
          this.getInfiniyHoldsData({ measureId: measureId }, signal);
          // PerformanceStore.setLoaderStatus("infinityReturns", "success");
          //PerformanceStore.loaderCloseFunction();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
        });
      return;
    }

    PerformanceStore.setLoaderStatus("infinityReturnsClient", "pending");

    infinityReturns({
      id: userId,
      advisor: this.getDataWithNuvamaOrOther,
      isFamily: "clients",
      signal,
    })
      .then(({ data }) => {
        const currentObj = data?.lstInstrumentReturns?.find(
          (eachData) => eachData.measureinstrumentid === measureId,
        );
        this.infinityHoldingData = currentObj;

        this.getInfiniyHoldsData({ measureId: measureId }, signal);
        // PerformanceStore.setLoaderStatus("infinityReturnsClient", "success");
        PerformanceStore.loaderCloseFunction();
      })
      .catch((error) => {});
  }

  setSelectedClientId(id) {
    this.selectedClientId = id;
  }

  setSelectedClientIdUserLogin(data) {
    if (!data.isprimary) {
      this.selectedClientId = data.user_id;
    }
  }

  removeInfinity() {
    this.isInfinity = "0";
    this.rememberedMeasureId = this.infinityMesurementId;
    this.infinityMesurementId = undefined;
  }

  setMesurementId(id) {
    this.rememberedMeasureId = this.infinityMesurementId;
    this.infinityMesurementId = id;
  }
  setInfinityNRemeberedMeasureId(id) {
    this.infinityMesurementId = id;
    this.rememberedMeasureId = id;
  }

  setMeasureIdForThirdLevel(id) {
    this.forThirdLevelMeasureId = id;
  }
  setRememberedMeasuredId(id) {
    this.rememberedMeasureId = this.infinityMesurementId;
  }

  updateModifiedData(data) {
    this.modifiedData = data;
  }

  updateRememberedModifiedData(data) {
    this.rememberedModifiedData = data;
  }

  updateModifiedInfinityData(data) {
    this.modifiedInfinityData = data;
  }
  updateModifiedRememberedInfinityData(data) {
    this.rememberedInfinityData = data;
  }

  getInfinityData({ onSuccess, onFail, page, signal }) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    AuthStore.updateLoadingFullScreen(true);
    this.setPortfolioLoader("quickViewInfinity", "pending");
    if (this.getData === "fam") {
      getInfinityData({
        isFamily: "families",
        id: familyId,
        advisor: this.getDataWithNuvamaOrOther,
        signal,
      })
        .then(({ data }) => {
          this.selectedInstrumentVehicle = {
            ...this.selectedInstrumentVehicle,
            //  vehicleDataArray: data.lstInstrumentReturns,
            modifiedVehicleData: data.lstInstrumentReturns.map((vehicle) => {
              return {
                data_Par_Value: vehicle.par_value_amt.actual_value || "-",
                data_Principle_Amt:
                  vehicle.principal_paid_amt?.actual_value || "-",
                data_Curr_Value:
                  vehicle.investmentreturn?.current_value.actual_value || "-",
                data_Inv_Value:
                  vehicle.investmentreturn?.invested_value.actual_value || "-",
                data_Int_Div:
                  vehicle?.investmentreturn?.int_div?.amount?.actual_value ||
                  "-",
                data_Unre_Gain:
                  vehicle.investmentreturn?.unrealised_gain?.amount
                    .actual_value || "-",
                data_Real_Gai:
                  vehicle.investmentreturn?.realised_gain.amount.actual_value ||
                  "-",
                data_Total_Gai:
                  vehicle.investmentreturn?.total_returns?.actual_value || "-",

                par_value: vehicle.par_value_amt.value || "-",
                par_unit: vehicle.par_value_amt.value_type,
                principal_paid_amt: vehicle.principal_paid_amt?.value || "",
                pp_unit: vehicle.principal_paid_amt?.value_type,
                actualWholeObject: vehicle,
                instrument_name: vehicle.instrument?.name,
                qty: vehicle.units || "",
                Avg_buy_price:
                  vehicle.average_buy_price && !isNaN(vehicle.average_buy_price)
                    ? Number(vehicle.average_buy_price)
                        ?.toFixed(2)
                        ?.toLocaleString("hi-IN")
                    : vehicle.average_buy_price,
                cmp:
                  vehicle.cmp && !isNaN(vehicle.cmp)
                    ? Number(vehicle.cmp)?.toFixed(2)?.toLocaleString("hi-IN")
                    : vehicle.cmp,
                current_value: {
                  subtext: vehicle.investmentreturn?.as_of_date,
                  text: `${
                    vehicle.investmentreturn?.current_value.value || "-"
                  }`,
                  textUnit: vehicle.investmentreturn?.current_value.value_type,
                },
                inv_value: `${
                  vehicle.investmentreturn?.invested_value.value || "-"
                }`,
                invUnit: vehicle.investmentreturn?.invested_value.value_type,
                int_div_others:
                  vehicle?.investmentreturn?.int_div?.amount?.value || "-",
                intDivUnit:
                  vehicle?.investmentreturn?.int_div?.amount?.value_type || "-",
                unrealised_gain: {
                  subtext:
                    vehicle.investmentreturn?.unrealised_gain?.percentage,
                  text: `${
                    vehicle.investmentreturn?.unrealised_gain?.amount.value ||
                    "-"
                  }`,
                  textUnit:
                    vehicle.investmentreturn?.unrealised_gain?.amount
                      .value_type,
                },
                unrealised_percentage:
                  vehicle.investmentreturn?.unrealised_gain?.percentage,

                realised_Gains: `${
                  vehicle.investmentreturn?.realised_gain.amount.value || "-"
                }`,
                realisedUnit:
                  vehicle.investmentreturn?.realised_gain.amount.value_type,
                as_on_date: vehicle.investmentreturn.as_of_date,
                total_gains: {
                  text: `${
                    vehicle.investmentreturn?.total_returns?.actual_value || "-"
                  }`,
                  textUnit: vehicle.investmentreturn?.total_returns?.value_type,
                },
                irr: vehicle.investmentreturn.irr,
                id: vehicle.instrument.id,
                instrumentId: vehicle.instrument.id,
                measure_instr_id: vehicle.instrument.measureinstrumentid,
                isUnitBased: vehicle.instrument.isUnitBased,
                isInterest: vehicle.instrument.isInterest,
              };
            }),
          };

          this.updateModifiedData(
            this.selectedInstrumentVehicle.modifiedVehicleData,
          );
          this.updateRememberedModifiedData(
            this.selectedInstrumentVehicle.modifiedVehicleData,
          );
          this.lstInstrumentReturnsFromHome = data.lstInstrumentReturns;

          this.totalCurrentValueFromHome = data.total_current_value;
          AuthStore.updateLoadingFullScreen(false);

          this.setPortfolioPath([
            {
              path: `/${page}`,
              show: `${page}`,
            },
            {
              path: `/${page}/${
                page === homePageRoute
                  ? "subassetclassdetailshome"
                  : "subassetclassdetailsQuick"
              }/${familyId}/fromHome`,
              show:
                page === homePageRoute
                  ? "Infinity"
                  : `${data?.lstInstrumentReturns?.length} Instruments in Infinity`,
              state: { from: "homeScreen" },
            },
          ]);
          if (this.isInfinity === "0" && this.isLive === "0") {
            this.setForNoInfinitySubAssetData(this.selectedInstrumentVehicle);
          }
          this.setPortfolioLoader("quickViewInfinity", "success");
          onSuccess(data);
        })
        .catch((error) => {
          onFail(error);
          this.setPortfolioLoader("quickViewInfinity", "failed");
          AuthStore.updateLoadingFullScreen(false);
        });
    } else {
      getInfinityData({
        isFamily: "clients",
        id: userId,
        advisor: this.getDataWithNuvamaOrOther,
        signal,
      })
        .then(({ data }) => {
          this.selectedInstrumentVehicle = {
            ...this.selectedInstrumentVehicle,
            //   vehicleDataArray: data.lstInstrumentReturns,
            modifiedVehicleData: data.lstInstrumentReturns.map((vehicle) => {
              return {
                data_Par_Value: vehicle.par_value_amt.actual_value || "-",
                data_Principle_Amt:
                  vehicle.principal_paid_amt?.actual_value || "-",
                data_Curr_Value:
                  vehicle.investmentreturn?.current_value.actual_value || "-",
                data_Inv_Value:
                  vehicle.investmentreturn?.invested_value.actual_value || "-",
                data_Int_Div:
                  vehicle?.investmentreturn?.int_div?.amount?.actual_value ||
                  "-",
                data_Unre_Gain:
                  vehicle.investmentreturn?.unrealised_gain?.amount
                    .actual_value || "-",
                data_Real_Gai:
                  vehicle.investmentreturn?.realised_gain.amount.actual_value ||
                  "-",
                data_Total_Gai:
                  vehicle.investmentreturn?.total_returns?.actual_value || "-",

                par_value: vehicle.par_value_amt.value || "-",
                par_unit: vehicle.par_value_amt.value_type,
                principal_paid_amt: vehicle.principal_paid_amt?.value || "",
                pp_unit: vehicle.principal_paid_amt?.value_type,
                actualWholeObject: vehicle,
                instrument_name: vehicle.instrument?.name,
                qty: vehicle.units || "",
                Avg_buy_price:
                  vehicle.average_buy_price && !isNaN(vehicle.average_buy_price)
                    ? Number(vehicle.average_buy_price)
                        ?.toFixed(2)
                        ?.toLocaleString("hi-IN")
                    : vehicle.average_buy_price,
                cmp:
                  vehicle.cmp && !isNaN(vehicle.cmp)
                    ? Number(vehicle.cmp)?.toFixed(2)?.toLocaleString("hi-IN")
                    : vehicle.cmp,
                current_value: {
                  subtext: vehicle.investmentreturn?.as_of_date,
                  text: `${
                    vehicle.investmentreturn?.current_value.value || "-"
                  }`,
                  textUnit: vehicle.investmentreturn?.current_value.value_type,
                },
                inv_value: `${
                  vehicle.investmentreturn?.invested_value.value || "-"
                }`,
                invUnit: vehicle.investmentreturn?.invested_value.value_type,
                int_div_others:
                  vehicle?.investmentreturn?.int_div?.amount?.value || "-",
                intDivUnit:
                  vehicle?.investmentreturn?.int_div?.amount?.value_type || "-",
                unrealised_gain: {
                  subtext:
                    vehicle.investmentreturn?.unrealised_gain?.percentage,
                  text: `${
                    vehicle.investmentreturn?.unrealised_gain?.amount.value ||
                    "-"
                  }`,
                  textUnit:
                    vehicle.investmentreturn?.unrealised_gain?.amount
                      .value_type,
                },
                unrealised_percentage:
                  vehicle.investmentreturn?.unrealised_gain?.percentage,

                realised_Gains: `${
                  vehicle.investmentreturn?.realised_gain.amount.value || "-"
                }`,
                realisedUnit:
                  vehicle.investmentreturn?.realised_gain.amount.value_type,
                as_on_date: vehicle.investmentreturn.as_of_date,
                total_gains: {
                  text: `${
                    vehicle.investmentreturn?.total_returns?.actual_value || "-"
                  }`,
                  textUnit: vehicle.investmentreturn?.total_returns?.value_type,
                },
                irr: vehicle.investmentreturn.irr,
                id: vehicle.instrument.id,
                instrumentId: vehicle.instrument.id,
                measure_instr_id: vehicle.instrument.measureinstrumentid,
                isUnitBased: vehicle.instrument.isUnitBased,
                isInterest: vehicle.instrument.isInterest,
              };
            }),
          };
          this.updateModifiedData(
            this.selectedInstrumentVehicle.modifiedVehicleData,
          );
          this.updateRememberedModifiedData(
            this.selectedInstrumentVehicle.modifiedVehicleData,
          );
          this.lstInstrumentReturnsFromHome = data.lstInstrumentReturns;
          this.totalCurrentValueFromHome = data.total_current_value;
          if (this.isInfinity === "0" && this.isLive === "0") {
            this.setForNoInfinitySubAssetData(this.selectedInstrumentVehicle);
          }
          AuthStore.updateLoadingFullScreen(false);
          this.setPortfolioPath([
            {
              path: `/${page}`,
              show: `${page}`,
            },
            {
              path: `/${page}/${
                page === homePageRoute
                  ? "subassetclassdetailshome"
                  : "subassetclassdetailsQuick"
              }/${familyId}/fromHome`,
              show:
                page === homePageRoute
                  ? "Infinity"
                  : `${data?.lstInstrumentReturns?.length} Instruments in Infinity`,
              state: { from: "homeScreen" },
            },
          ]);
          this.setPortfolioLoader("quickViewInfinity", "success");
          onSuccess(data);
        })
        .catch((error) => {
          onFail(error);
          this.setPortfolioLoader("quickViewInfinity", "failed");
          AuthStore.updateLoadingFullScreen(false);
        });
    }
  }

  setIsNavigated(data) {
    this.isNavigated = data;
  }

  changeIsLive() {
    this.isLive = this.isLive === "1" ? "0" : "1";
    let condition = this.toggleLive;
    this.toggleLive = !condition;
  }
  changeIsLiveToZero(data, data2) {
    let localData = data;
    let localData2 = data2;
    this.isLive = localData;
    this.toggleLive = localData2;
  }

  changeIsLiveOnly(data) {
    this.isLive = data;
  }

  infinityClick(sliceValue, othr) {
    this.portfolioPath.splice(sliceValue);
  }

  analyticsClick(sliceValue) {
    this.analyticsPath.splice(sliceValue);
  }

  removeBreadsLastElem() {
    let breadPath = this.portfolioPath;
    breadPath.pop();
    this.portfolioPath = breadPath;
  }

  setPortfolioPathInitial(data) {
    this.portfolioPath = data;
  }

  setPortfolioPath(pathArray, add, remove) {
    if (remove) {
      this.portfolioPath?.pop();
      return;
    }
    if (add) {
      if (!pathArray.path1) {
        const newPath = [...this.portfolioPath, pathArray];
        const set1 = new Set(newPath);
        this.portfolioPath = [...set1];
      } else {
        const portfolioPath = this.portfolioPath;
        if (this.portfolioPath.length !== 2) this.portfolioPath.pop();
        this.portfolioPath?.[portfolioPath.length - 1]?.show ===
          "Infinity Holdings" && this.portfolioPath?.pop();

        this.portfolioPath = [
          ...this.portfolioPath,
          pathArray.path1,
          pathArray.path2,
        ];
      }
      return;
    }
    this.portfolioPath = pathArray;
  }

  setInfinity(data) {
    this.isInfinity = data;
  }

  uploadRealEstateImage({ image, realestateId, onSuccess, onFail }) {
    let formData = new FormData();
    formData.append("image", image);
    const userId = this.userData.user_id || getCookie("userid");

    if (this.getData === "fam") {
      plainApiClient
        .post(
          `clients/${userId}/realestates/${realestateId}/profilepictures`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              isform: true,
            },
          },
        )
        .then(({ data }) => {
          onSuccess(data);
          AuthStore.updateLoadingFullScreen(false);
        })
        .catch((error) => {
          onFail && onFail();
          AuthStore.updateLoadingFullScreen(false);
        });
      return;
    }

    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    plainApiClient
      .post(
        `clients/${userId}/realestates/${realestateId}/profilepictures`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            isform: true,
          },
        },
      )
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        onFail && onFail();
        AuthStore.updateLoadingFullScreen(false);
      });
  }

  convertDataToTableFormat = (item, index) => {
    return {
      instrument_name: item.instrument?.name,
      qty: item.units || "0.00",
      Avg_buy_price: item.average_buy_price,
      cmp: item.cmp,
      current_value: {
        subtext: item.investmentreturn?.as_of_date,
        text: `${
          lakhAmt(item.investmentreturn?.current_value.actual_value) || "-"
        }`,
      },
      dataCurrValue: item.investmentreturn?.current_value.value,
      dataCurreValueUnit: item.investmentreturn?.current_value.value_type,

      inv_value: `${
        lakhAmt(item.investmentreturn?.invested_value.actual_value) || "-"
      }`,
      dataInvValue: item.investmentreturn?.invested_value.value,
      dataInvUnit: item.investmentreturn?.invested_value.value_type,

      int_div_others: `${
        lakhAmt(item.investmentreturn?.total_returns.actual_value) || "-"
      }`,
      dataIntDiv: item.investmentreturn?.total_returns.value,
      dataIntDivUnit: item.investmentreturn?.total_returns.value_type,

      unrealised_gain: {
        subtext: item.investmentreturn?.unrealised_gain?.percentage,
        text: `${
          lakhAmt(
            item.investmentreturn?.unrealised_gain?.amount?.actual_value,
          ) || "-"
        }`,
      },
      datUnrealGain: item.investmentreturn?.unrealised_gain?.amount?.value,
      dataUnrelUnit: item.investmentreturn?.unrealised_gain?.amount?.value_type,

      realised_Gains: `${
        lakhAmt(item.investmentreturn?.realised_gain.amount.actual_value) || "-"
      }`,
      dataReal: item.investmentreturn?.realised_gain.amount.value,
      dataRealUnit: item.investmentreturn?.realised_gain.amount.value_type,

      irr: item.investmentreturn.irr,
      as_on_date: item.investmentreturn?.as_of_date,
      id: item.instrument.id,
      instrumentId: item.instrument.id,
      measure_instr_id: item.instrument.measureinstrumentid,
    };
  };

  getDataInExcelFormat = (item) => {
    return {
      asset_class: item.assetClass.name,
      allocation: getLimitPer(item.allocation_percentage),
      curr_value:
        getExcelNumData2(
          item.investmentreturn.current_value.actual_value,
          false,
          2,
        ) || "-",
      inv_value: getExcelNumData2(
        item.investmentreturn.invested_value.actual_value,
        false,
        2,
      ),
      int_div:
        !isNaN(item.investmentreturn.int_div.amount.actual_value || "-") &&
        Number(item.investmentreturn.int_div.amount.actual_value) !== 0
          ? //item.investmentreturn.int_div.amount.actual_value != 0
            getExcelNumData2(
              item.investmentreturn.int_div.amount.actual_value,
              false,
              2,
            )
          : "-",
      unrealised_gain: getExcelNumData2(
        item.investmentreturn.unrealised_gain.amount.actual_value,
        false,
        2,
      ),
      unrealised_percentage: getLimitPer(
        item.investmentreturn.unrealised_gain.percentage,
        // false,
        // 2
      ),
      realised_gain: getExcelNumData2(
        item.investmentreturn.realised_gain.amount.actual_value,
        false,
        2,
      ),
      irr: getLimitPer(
        item.investmentreturn.irr,
        // false,
        // 2
      ),
      instrumentVehiclesList: item.instrumentVehiclesList,
    };
  };

  setSelectedInstrument(data) {
    this.instrumentDetails = { ...this.instrumentDetails, details: data };
  }

  setClientOrFamily(data, from) {
    this.getData = data;
    if (from?.from === "SELECT") return;
  }

  getSfLoginDetais({ token, userId, empId, onSuccess }) {
    apiClient
      .post(`Login/SfLogin?token=${token}&userId=${userId}&empId=${empId}`)
      .then(({ data }) => {
        AuthStore.setAuthSession({
          AuthToken: data.token,
          SecreteKey: data.secretKey,
        });
        const primaryClient = data.familiesList[0].memberList?.find(
          (eachData) => eachData.isprimary,
        );

        this.setSelectedClientId("0");
        ReportsStore.updatePortfolioReportFilterData("All", "mod5");
        ReportsStore.updateTransactionFilterData("All", "check4");
        ReportsStore.updateCorporateFilterData("All");
        this.setClientOrFamily("fam");
        PerformanceStore.setFamOrClient({
          name: "fam",
          id: primaryClient.user_id,
        });
        this.setIsPrimary(primaryClient.isprimary);
        this.setUserData(
          {
            ...primaryClient,
            family_name: data.familiesList[0].family_name,
            allMembers: primaryClient.isprimary,
          },
          "whileLogginIn",
        );
        setCookie("name", primaryClient?.full_name);
        onSuccess();
      })
      .catch((err) => {});
  }

  setSelectWithNuvama(selected, checked) {
    const _object = {
      others: "withOthers",
      nuvama: "withNuvama",
    };

    const localValues = {
      others: getCookie("withOthers") === "1",
      nuvama: getCookie("withNuvama") === "1",
    };

    if (getCookie("withNuvama") === "1" && getCookie("withOthers") === "0") {
      if (checked === false) {
        setCookie("withNuvama", "1");
        setCookie("withOthers", "1");
      } else {
        setCookie("withNuvama", "0");
        setCookie("withOthers", "1");
      }
    } else {
      setCookie(_object[selected], localValues[selected] ? "0" : "1");
    }

    let storageOthers = getCookie("withOthers") === "1";
    let storageNuvama = getCookie("withNuvama") === "1";

    if (!storageNuvama && !storageOthers) {
      if (selected === "others") {
        setCookie("withNuvama", 1);
      } else {
        setCookie("withOthers", 1);
      }
    }
    if (storageNuvama && storageOthers) {
      this.getDataWithNuvamaOrOther = "all";
    } else {
      this.getDataWithNuvamaOrOther = storageOthers ? "others" : "edelweiss";
    }

    this.withNuvama = getCookie("withNuvama") === "1";
    this.withOthers = getCookie("withOthers") === "1";
  }

  setSelectedInstrumentVehicle(data) {
    this.selectedInstrumentVehicle = {
      ...this.selectedInstrumentVehicle,
      ...data,
    };

    this.updateRememberedModifiedData(data?.modifiedVehicleData);
    this.updateModifiedData(data?.modifiedVehicleData);
  }

  setPagesApiStatus(type, subType, status) {
    this[type][subType] = status;
  }

  getFamilyClients(isOtherApi, onSuccess, onFail, signal) {
    const familyId = this.userData.family_id || getCookie("famid");

    if (isOtherApi === "forImg" || isOtherApi === "performance") {
      PerformanceStore.setLoaderStatus("famclient", "pending");
    } else {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
    }

    familyMembers(!signal ? { familyId } : { familyId, signal })
      .then(({ data }) => {
        if (onSuccess) {
          onSuccess(data);
          !signal && AuthStore.updateLoadingFullScreen(false);
        }
        this.currentFamilyMembers = data;
        const user_id = data[0]?.user_id;
        const liason_id = data[0]?.liasonOfficers?.[0]?.liasonOfficerId;
        const forLiaison = data?.filter(
          (eachData) => eachData.user_id === Number(getCookie("userid")),
        );
        ReportsStore.setMapData(forLiaison);
        if (isOtherApi === "performance") {
          PerformanceStore.getInvestmentHeldWith(
            this.userData.user_id || getCookie("userid"),
          );
        } else if (isOtherApi === "nonPrimaryProfile") {
          ProfileStore2.callForNonPrimary(
            this.userData.user_id || getCookie("userid"),
            forLiaison[0]?.liasonOfficers?.[0]?.liasonOfficerId,
            forLiaison,
          );
        } else if (isOtherApi === "nonPrimary") {
          ReportsStore.getSingleUsersAccount(getCookie("userid"));
        }

        const imageArr = {};
        if (isOtherApi === "forImg" || isOtherApi === "performance") {
          data?.forEach((eachClient) => {
            if (eachClient.profile_pic) {
              PerformanceStore.setLoaderStatusForImage(
                `${eachClient.user_id}2`,
                "pending",
              );
              ProfileStore2.getImageFromAPIProfile({
                path: eachClient.profile_pic,
                onSuccess: (imageBlob) => {
                  getBlobToBase64(imageBlob).then((url) => {
                    let resImage = url;
                    imageArr[eachClient.user_id] = resImage;
                    this.currentFamilyMembersImages = {
                      ...this.currentFamilyMembersImages,
                      ...imageArr,
                    };
                    PerformanceStore.setLoaderStatusForImage(
                      `${eachClient.user_id}2`,
                      "success",
                    );
                    PerformanceStore.loaderCloseFunction();
                  });
                },
                onFail: (error) => {},
                from: "portfolio",
              });
            }
          });
        } else {
          data?.forEach((eachClient) => {
            if (eachClient.profile_pic) {
              SettingsStore.getImageFromAPI({
                path: eachClient.profile_pic,
                onSuccess: (imageBlob) => {
                  getBlobToBase64(imageBlob).then((url) => {
                    let resImage = url;
                    imageArr[eachClient.user_id] = resImage;
                    this.currentFamilyMembersImages = {
                      ...this.currentFamilyMembersImages,
                      ...imageArr,
                    };
                  });
                },
              });
            }
          });
        }
        if (isOtherApi === "profile") {
          ProfileStore2.callApi(data.length, user_id, liason_id);
        } else if (isOtherApi === "offloader") {
          ProfileStore2.mapUsers(this.currentFamilyMembers);
          AuthStore.updateLoadingFullScreen(false);
        }

        if (isOtherApi === "forImg" || isOtherApi === "performance") {
          PerformanceStore.setLoaderStatus("famclient", "success");
          PerformanceStore.loaderCloseFunction();
        } else {
          AuthStore.updateLoadingFullScreen(false);
        }
      })
      .catch((error) => {
        if (onFail) {
          AuthStore.updateLoadingFullScreen(false);
          onFail(error);
        } else if (isOtherApi === "forImg" || isOtherApi === "performance") {
          PerformanceStore.loaderCloseOnFail();
        }
      });
  }

  getInstrumentData({ instrumentId, measureinstrumentid, folioNumber }) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    if (this.getData === "fam") {
      PerformanceStore.setLoaderStatus("instruTransaction", "pending");

      const fixData = {
        isInfinity: this.isInfinity,
        advisor: this.getDataWithNuvamaOrOther,
        measureinstrumentid,
      };

      const params = !folioNumber ? fixData : { ...fixData, folioNumber };

      usersTransaction({
        isFamily: "families",
        id: familyId,
        instrumentId,
        params,
      })
        .then(({ data }) => {
          this.instrumentDetails = {
            ...this.instrumentDetails,
            transaction: data,
          };
          PerformanceStore.setLoaderStatus("instruTransaction", "success");
          PerformanceStore.loaderCloseFunction();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
        });
      PerformanceStore.setLoaderStatus("instruTax", "pending");

      getUserTaxLots({
        isFamily: "families",
        id: familyId,
        instrumentId,
        params: {
          measureinstrumentid,
        },
      })
        .then(({ data }) => {
          const newData = data?.map((eachData, index) => {
            const newDate = eachData.date ? eachData?.date?.split("/") : "";

            return {
              ...eachData,
              date: newDate ? `${newDate[2]}-${newDate[1]}-${newDate[0]}` : "",
            };
          });
          this.instrumentDetails = {
            ...this.instrumentDetails,
            taxLots: newData,
          };
          PerformanceStore.setLoaderStatus("instruTax", "success");
          PerformanceStore.loaderCloseFunction();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
        });
      return;
    }
    PerformanceStore.setLoaderStatus("instruTransactionClient", "pending");

    usersTransaction({
      isFamily: "clients",
      id: userId,
      instrumentId,
      params: {
        isInfinity: this.isInfinity,
        advisor: this.getDataWithNuvamaOrOther,
        measureinstrumentid,
      },
    })
      .then(({ data }) => {
        this.instrumentDetails = {
          ...this.instrumentDetails,
          transaction: data,
        };
        PerformanceStore.setLoaderStatus("instruTransactionClient", "success");
        PerformanceStore.loaderCloseFunction();
      })
      .catch((error) => {
        PerformanceStore.loaderCloseOnFail();
      });

    PerformanceStore.setLoaderStatus("instruTaxClient", "pending");

    getUserTaxLots({
      isFamily: "clients",
      id: userId,
      instrumentId,
      params: {
        measureinstrumentid,
      },
    })
      .then(({ data }) => {
        const newData = data?.map((eachData, index) => {
          const newDate = eachData.date ? eachData?.date?.split("/") : "";

          return {
            ...eachData,
            date: newDate ? `${newDate[2]}-${newDate[1]}-${newDate[0]}` : "",
          };
        });
        this.instrumentDetails = {
          ...this.instrumentDetails,
          taxLots: newData,
        };

        PerformanceStore.setLoaderStatus("instruTaxClient", "success");
        PerformanceStore.loaderCloseFunction();
      })
      .catch((error) => {
        PerformanceStore.loaderCloseOnFail();
      });
  }

  getRealEstateData({ signal }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    this._getUsersRealEstateData({
      apiPreFix: resourceApi.resourceApiPrefix,
      onSuccess: (data) => {
        this.realEstateData = data;

        //const imageArr = {};
        // data?.forEach((eachClient) => {
        //   if (eachClient.profile_pic) {
        //     PerformanceStore.setLoaderStatus(`${eachClient.id}Real`, "pending");
        //     SettingsStore.getImageFromAPI({
        //       path: eachClient.profile_pic,
        //       onSuccess: (imageBlob) => {
        //         getBlobToBase64(imageBlob).then((url) => {
        //           let resImage = url;
        //           imageArr[eachClient.id] = resImage;
        //           this.realEstateImage = {
        //             ...this.realEstateImage,
        //             ...imageArr,
        //           };
        //         });
        //         PerformanceStore.setLoaderStatus(
        //           `${eachClient.id}Real`,
        //           "success"
        //         );
        //         PerformanceStore.loaderCloseFunction();
        //       },
        //       onFail: () => {
        //         PerformanceStore.setLoaderStatus(
        //           `${eachClient.id}Real`,
        //           "failed"
        //         );
        //         PerformanceStore.loaderCloseFunction();
        //         imageArr[eachClient.id] = "";
        //         this.realEstateImage = {
        //           ...this.realEstateImage,
        //           ...imageArr,
        //         };
        //       },
        //     });
        //   }
        // });
        PerformanceStore.setLoaderStatus("realEsateData", "success");
        PerformanceStore.loaderCloseFunction();
        this.portfolioTabsStatus.realEstate = true;
      },
      onFail: (error) => {
        PerformanceStore.loaderCloseOnFail();
      },
      signal,
    });
  }

  getConnectDetails = () => {
    pointOfConnect(this.userData.user_id || getCookie("userid"))
      .then(({ data }) => {
        this.exportDetails = data;
      })
      .catch((error) => {});
  };

  setForNoInfinitySubAssetData(data) {
    this.nonInfinitySubAssetData = data;
  }

  downloadImagesOnApiCall(arrData) {
    const imageArr = {};
    PerformanceStore.setCurrentLoader("loginLoader");
    PerformanceStore.setPerformanceLoader("loginLoader", true);
    arrData.forEach((eachFamily) => {
      eachFamily.memberList.forEach((eachClient) => {
        if (
          eachClient.profile_pic &&
          !AuthStore.selectFamiliesPageAllImages[eachClient.user_id] &&
          PerformanceStore.loaderClosingCheck[`${eachClient.user_id}1`] !==
            "pending"
        ) {
          PerformanceStore.setLoaderStatus(`${eachClient.user_id}1`, "pending");
          SettingsStore.getImageFromAPI({
            path: eachClient.profile_pic,
            onSuccess: (imageBlob) => {
              getBlobToBase64(imageBlob).then((url) => {
                let resImage = url;
                imageArr[eachClient.user_id] = resImage;
                AuthStore.updateSelectFamiliesPageAllImages(imageArr);
                PerformanceStore.setLoaderStatus(
                  `${eachClient.user_id}1`,
                  "success",
                );
                PerformanceStore.loaderCloseFunction();
              });
            },
            onFail: (error) => {
              PerformanceStore.setLoaderStatus(
                `${eachClient.user_id}1`,
                "failed",
              );
            },
          });
        }
      });
    });

    PerformanceStore.loaderCloseFunction();
  }

  setSelectedContact(data) {
    this.selectedContact = data;
  }

  setConnectData(data) {
    this.connectData = data;
  }

  addToPortfolio(data) {
    this.portfolio = { ...this.portfolio, ...data };
  }

  addToOffshoreData(data) {
    this.offshoreData = { ...this.offshoreData, ...data };
  }

  setEmployeeFamilies(data) {
    this.employeeFamilies = data;
  }

  updateWholeFamilies(data) {
    this.rememberedFamilyData = data;
  }

  setDeviceId(id) {
    this.userDeviceId = id;
  }

  updateShowFamilyData(data) {
    this.showFamilyData = data;
  }

  _getFamilyPortfolio({ userId, onSuccess, onFail, signal }) {
    getFamilyPortfolio(userId, this.getDataWithNuvamaOrOther, signal)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getFamilyView({ user_id, advisor, onSuccess, onFail, signal }) {
    getFamilyView({ user_id, advisor, signal })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getFamilyPortfolioReturn({ userId, onSuccess, onFail, signal }) {
    getFamilyPortfolioReturn(
      userId,
      this.getDataWithNuvamaOrOther,
      this.isInfinity,
      signal,
    )
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getFamilyPortfolioReturnInfinity({
    userId,
    measureId,
    onSuccess,
    onFail,
    signal,
  }) {
    getFamilyPortfolioReturnInfinity(
      userId,
      this.getDataWithNuvamaOrOther,
      this.isInfinity,
      measureId,
      signal,
    )
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getFamilyRecentTransaction({ userId, onSuccess, onFail }) {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    this.homeLoad = true;
    getFamilyRecentTransaction(userId, this.getDataWithNuvamaOrOther)
      .then(({ data }) => {
        onSuccess(data);
        this.homeLoad = false;
      })
      .catch((error) => {
        onFail && onFail(error);
        this.homeLoad = false;
      });
  }

  _getFamilyCorporateActions({ userId, onSuccess, onFail }) {
    getFamilyCorporateActions(userId, this.getDataWithNuvamaOrOther)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getClientPortfolioReturn({ userId, onSuccess, onFail, signal }) {
    getClientPortfolioReturn(
      userId,
      this.getDataWithNuvamaOrOther,
      this.isInfinity,
      signal,
    )
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getClientPortfolioReturnInfinity({
    userId,
    measureId,
    onSuccess,
    onFail,
    signal,
  }) {
    getClientPortfolioReturnInfinity(
      userId,
      this.getDataWithNuvamaOrOther,
      this.isInfinity,
      measureId,
      signal,
    )
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getClientPortfolio({ userId, onSuccess, onFail, signal }) {
    getClientPortfolio(userId, this.getDataWithNuvamaOrOther, signal)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getClientRecentTransaction({ userId, onSuccess, onFail }) {
    this.homeLoad = true;
    getClientRecentTransaction(userId, this.getDataWithNuvamaOrOther)
      .then(({ data }) => {
        onSuccess(data);
        AuthStore.updateLoadingFullScreen(false);
        this.homeLoad = false;
      })
      .catch((error) => {
        onFail(error);
        AuthStore.updateLoadingFullScreen(false);
        this.homeLoad = false;
      });
  }

  _getClientCorporateActions({ userId, onSuccess, onFail }) {
    getClientCorporateActions(userId, this.getDataWithNuvamaOrOther)
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  _getUsersPortfolioReturn({ apiPreFix, currency, onSuccess, onFail, signal }) {
    getUsersPortfolioReturn({
      apiPreFix,
      advisor: this.getDataWithNuvamaOrOther,
      isInfinity: this.isInfinity,
      IsOffshore: true,
      currency,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersPortfolio({ apiPreFix, currency, onSuccess, onFail, signal }) {
    getUsersPortfolio({
      apiPreFix,
      advisor: this.getDataWithNuvamaOrOther,
      IsOffshore: true,
      currency,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersPortfolioAssetClasses({
    apiPreFix,
    onSuccess,
    onFail,
    meta: { signal, isLive, isInfinity, currency, ...params },
  }) {
    getUsersPortfolioAssetClasses({
      apiPreFix,
      signal,
      advisor: this.getDataWithNuvamaOrOther,
      isLive,
      isInfinity,
      IsOffshore: true,
      currency,
      ...params,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersSubAssetClasses({
    apiPreFix,
    onSuccess,
    onFail,
    meta: { signal, isInfinity, currency },
  }) {
    getUsersSubAssetClasses({
      apiPreFix,
      signal,
      isInfinity,
      IsOffshore: true,
      currency,
      advisor: this.getDataWithNuvamaOrOther,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersReturnsLine({
    apiPreFix,
    onSuccess,
    onFail,
    meta: { signal, currency },
  }) {
    getUsersReturnsLine({
      apiPreFix,
      IsOffshore: true,
      currency,
      signal,
      IsOffshore: true,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersFamilyView({
    user_id,
    advisor,
    currency,
    onSuccess,
    onFail,
    signal,
  }) {
    getUsersFamilyView({
      client_id: user_id,
      advisor,
      currency,
      signal,
      IsOffshore: true,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersCurrency({ params, signal, onSuccess, onFail }) {
    getUsersCurrency({ params, signal })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  _getPortfolioReturn({ apiPreFix, onSuccess, onFail, signal }) {
    getPortfolioReturn({
      apiPreFix,
      advisor: this.getDataWithNuvamaOrOther,
      isInfinity: this.isInfinity,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getPortfolio({ apiPreFix, onSuccess, onFail, signal }) {
    getPortfolio({ apiPreFix, advisor: this.getDataWithNuvamaOrOther, signal })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersRealEstateData({ apiPreFix, onSuccess, onFail, signal }) {
    getUsersRealEstateData({ apiPreFix, signal })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersDerivativesData({ apiPreFix, onSuccess, onFail, signal }) {
    getUsersDerivativesData({
      apiPreFix,
      advisor: this.getDataWithNuvamaOrOther,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersPortfolioDerivativesData({
    apiPreFix,
    item,
    onSuccess,
    onFail,
    signal,
  }) {
    getUsersPortfolioDerivativesData({
      apiPreFix,
      item,
      advisor: this.getDataWithNuvamaOrOther,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersLiabilitieslas({ apiPreFix, onSuccess, onFail, signal }) {
    getUsersLiabilitieslas({
      apiPreFix,
      advisor: this.getDataWithNuvamaOrOther,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersLiabilities({ apiPreFix, onSuccess, onFail, signal }) {
    getUsersLiabilities({
      apiPreFix,
      advisor: this.getDataWithNuvamaOrOther,
      signal,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersInstrumentReturns({
    apiPreFix,
    onSuccess,
    onFail,
    signal,
    ...rest
  }) {
    getUsersInstrumentReturns({
      apiPreFix,
      signal,
      ...rest,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersTransactions({ apiPreFix, onSuccess, onFail, signal, ...rest }) {
    getUsersTransactions({
      apiPreFix,
      signal,
      ...rest,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail && onFail(error);
      });
  }

  _getUsersInvestmentDetailsOffshore({ onSuccess, onFail, signal, ...rest }) {
    getUsersInvestmentDetailsOffshore({
      signal,
      advisor: this.getDataWithNuvamaOrOther,
      ...rest,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  setRef(refId, page) {
    if (page === "normal") {
      this.selectedRefId = refId;
    } else if (page === "subasset") {
      this.selectedRefIdSub = refId;
    } else {
      this.selectedRefIdInfinity = refId;
    }
  }

  checkLiabilitiesStatus() {
    if (
      this.liabilitiesStatus === "failure" ||
      this.liabilitieslasStatus === "failure"
    )
      this.portfolioTabsStatus.liabilities = false;
    else if (
      this.liabilitiesStatus === "success" &&
      this.liabilitieslasStatus === "success"
    ) {
      this.portfolioTabsStatus.liabilities = true;
    }
  }

  getLiabilitieslas({ signal }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    this.liabilitieslasStatus = "pending";
    PerformanceStore.setLoaderStatus("liabilitiesLas", "pending");

    this._getUsersLiabilitieslas({
      apiPreFix: resourceApi.resourceApiPrefix,
      onSuccess: (data) => {
        let data2 = data;
        let newData = getLas(data2);

        this.addToPortfolio({ clientLas: newData });
        PerformanceStore.setLoaderStatus("liabilitiesLas", "success");
        PerformanceStore.loaderCloseFunction();
        this.liabilitieslasStatus = "success";
        this.checkLiabilitiesStatus();
      },
      onFail: (error) => {
        this.liabilitieslasStatus = "failure";
        this.checkLiabilitiesStatus();
        PerformanceStore.loaderCloseOnFail();
      },
      signal,
    });
  }
  getLiabilities({ signal }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    this.liabilitiesStatus = "pending";
    PerformanceStore.setLoaderStatus("liabilities", "pending");

    this._getUsersLiabilities({
      apiPreFix: resourceApi.resourceApiPrefix,
      onSuccess: (data) => {
        this.addToPortfolio({ clientLiabilities: data });
        PerformanceStore.setLoaderStatus("liabilities", "success");
        PerformanceStore.loaderCloseFunction();
        this.liabilitiesStatus = "success";
        this.checkLiabilitiesStatus();
      },
      onFail: (error) => {
        this.liabilitiesStatus = "failure";
        PerformanceStore.loaderCloseOnFail();
        this.checkLiabilitiesStatus();
      },
      signal,
    });
  }

  getQuickViews({ signal }) {
    const userId = this.userData.user_id || getCookie("userid");
    const familyId = this.userData.family_id || getCookie("famid");

    if (this.getData === "fam") {
      PerformanceStore.setLoaderStatus("quickview", "pending");
      // apiClient
      //   .get(
      //     `families/${familyId}/portfolio/quickviews?advisor=${this.getDataWithNuvamaOrOther}`
      //   )
      getQuickViews({
        id: familyId,
        isFamily: "families",
        advisor: this.getDataWithNuvamaOrOther,
        signal,
      })
        .then(({ data }) => {
          this.clientQuickviews = data;
          PerformanceStore.setLoaderStatus("quickview", "success");
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.QuickViews = "success";
          this.checkFinancialApisStatus();
        })
        .catch((err) => {
          PerformanceStore.loaderCloseOnFail();
          this.financialApiStatus.QuickViews = "failure";
          this.checkFinancialApisStatus();
        });
    } else {
      PerformanceStore.setLoaderStatus("quickview", "pending");

      getQuickViews({
        id: userId,
        isFamily: "clients",
        advisor: this.getDataWithNuvamaOrOther,
        signal,
      })
        .then(({ data }) => {
          this.clientQuickviews = data;
          PerformanceStore.setLoaderStatus("quickview", "success");
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.QuickViews = "success";
          this.checkFinancialApisStatus();
        })
        .catch((err) => {
          PerformanceStore.loaderCloseOnFail();
          this.financialApiStatus.QuickViews = "failure";
          this.checkFinancialApisStatus();
        });

      this._getClientPortfolio({
        userId,
        onSuccess: (data) => {
          this.addToPortfolio({ clientPortfolio: data });
          this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
        },
        onFail: (error) => {
          PerformanceStore.loaderCloseOnFail();
        },
      });
    }
  }
  getQuickViewDetails({ id, type }) {
    const userId = this.userData.user_id || getCookie("userid");
    const familyId = this.userData.family_id || getCookie("famid");
    if (this.getData === "fam") {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      apiClient
        .get(`families/${familyId}/portfolio/instrumenttypes/${id}/instruments`)
        .then(({ data }) => {
          this.quickViewDetails = {
            ...this.quickViewDetails,
            quickViewDetails: data,
            instrumentList: data.lstInstrumentReturns.map(
              this.convertDataToTableFormat,
            ),
          };
          AuthStore.updateLoadingFullScreen(false);
        })
        .catch((error) => {
          AuthStore.updateLoadingFullScreen(false);
          PerformanceStore.loaderCloseOnFail();
        });
      return;
    }
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    apiClient
      .get(`clients/${userId}/portfolio/instrumenttypes/${id}/instruments`)
      .then(({ data }) => {
        this.quickViewDetails = {
          quickViewDetails: data,
          instrumentList: data.lstInstrumentReturns.map(
            this.convertDataToTableFormat,
          ),
        };
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
      });
    return;
  }
  setCurrentQuickView({ type, id, signal }) {
    this.quickViewDetails = {
      ...this.quickViewDetails,
      id: id,
    };

    const userId = this.userData.user_id || getCookie("userid");
    const familyId = this.userData.family_id || getCookie("famid");
    if (this.getData === "fam") {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);

      quickView({
        isFamily: "families",
        id: familyId,
        instrumentId: id,
        advisor: this.getDataWithNuvamaOrOther,
        signal,
      })
        .then(({ data }) => {
          this.quickViewDetails = {
            ...this.quickViewDetails,
            quickViewDetails: data,
            instrumentList: data.lstInstrumentReturns.map(
              this.convertDataToTableFormat,
            ),
          };

          this.setPortfolioPath([
            {
              path: "/portfolio",
              show: "Portfolio",
            },
            {
              path: `/portfolio/${id}`,
              show: `${data?.lstInstrumentReturns.length} Instruments in ${type}`,
            },
          ]);

          AuthStore.updateLoadingFullScreen(false);
        })
        .catch((error) => {
          AuthStore.updateLoadingFullScreen(false);
          PerformanceStore.loaderCloseOnFail();
        });
      return;
    }
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);

    quickView({
      isFamily: "clients",
      id: userId,
      instrumentId: id,
      advisor: this.getDataWithNuvamaOrOther,
      signal,
    })
      .then(({ data }) => {
        this.quickViewDetails = {
          ...this.quickViewDetails,
          quickViewDetails: data,
          instrumentList: data.lstInstrumentReturns.map(
            this.convertDataToTableFormat,
          ),
        };
        this.setPortfolioPath([
          {
            path: "/portfolio",
            show: "Portfolio",
          },
          {
            path: `/portfolio/${id}`,
            show: `${data?.lstInstrumentReturns.length} Instruments in ${type}`,
          },
        ]);
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
      });
    return;
  }

  quickViewApiCall() {
    const userId = this.userData.user_id || getCookie("userid");
    const familyId = this.userData.family_id || getCookie("famid");
    if (this.getData === "fam") {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      apiClient
        .get(
          `families/${familyId}/portfolio/instrumenttypes/${this.quickViewDetails.id}/instruments`,
        )
        .then(({ data }) => {
          this.quickViewDetails = {
            ...this.quickViewDetails,
            quickViewDetails: data,
            instrumentList: data.lstInstrumentReturns.map(
              this.convertDataToTableFormat,
            ),
          };
          AuthStore.updateLoadingFullScreen(false);
        })
        .catch((error) => {
          AuthStore.updateLoadingFullScreen(false);
          PerformanceStore.loaderCloseOnFail();
        });
      return;
    }
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    apiClient
      .get(
        `clients/${userId}/portfolio/instrumenttypes/${this.quickViewDetails.id}/instruments`,
      )
      .then(({ data }) => {
        this.quickViewDetails = {
          ...this.quickViewDetails,
          quickViewDetails: data,
          instrumentList: data.lstInstrumentReturns.map(
            this.convertDataToTableFormat,
          ),
        };
        AuthStore.updateLoadingFullScreen(false);
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
      });
    return;
  }

  getDerivativesData({ signal }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    PerformanceStore.setLoaderStatus("derivativePage", "pending");
    this.portfolio.clientDerivatives?.forEach((item, index) => {
      this._getUsersPortfolioDerivativesData({
        apiPreFix: resourceApi.resourceApiPrefix,
        item,
        onSuccess: (data) => {
          this.derivativesDetails[index] = data;
          if (index === this.portfolio.clientDerivatives?.length - 1) {
            PerformanceStore.setLoaderStatus("getFirstDeri", "success");

            PerformanceStore.setLoaderStatus("derivativePage", "success");
            PerformanceStore.loaderCloseFunction();
            this.portfolioTabsStatus.derivatives = true;
          }
        },
        onFail: (error) => {
          PerformanceStore.loaderCloseOnFail();
          this.portfolioTabsStatus.derivatives = false;
        },
        signal,
      });
    });
  }

  callApis(url, keyName, addToPortfolio, isScroll) {
    if (!isScroll) window.scrollTo(0, 0);

    apiClient
      .get(url)
      .then(({ data }) => {
        addToPortfolio({ [keyName]: data });
        if (keyName === "clientDerivatives") {
          if (data.length === 0) {
            PerformanceStore.setLoaderStatus("getFirstDeri", "success");
            PerformanceStore.loaderCloseFunction();
            this.portfolioTabsStatus.derivatives = true;
          }
          this.getDerivativesData();
        }
        if (keyName === "clientGetSubAssetClass" && this.getData === "fam") {
          PerformanceStore.setLoaderStatus("clientGetSubAssetClass", "success");
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.subAssetClass = "success";
          this.checkFinancialApisStatus();
        }
        if (keyName === "clientGetSubAssetClass" && this.getData !== "fam") {
          PerformanceStore.setLoaderStatus("getportfolioasset", "success");
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.subAssetClass = "success";
          this.checkFinancialApisStatus();
        }
      })
      .catch((error) => {
        PerformanceStore.loaderCloseOnFail();
        if (keyName === "clientGetSubAssetClass") {
          this.financialApiStatus.subAssetClass = "failure";
          this.checkFinancialApisStatus();
        }
      });
  }

  setFamilyName(name) {
    this.usersFamilyName = name;
  }

  getDerivative({ signal }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    this._getUsersDerivativesData({
      apiPreFix: resourceApi.resourceApiPrefix,
      onSuccess: (data) => {
        this.addToPortfolio({ clientDerivatives: data });
        if (data.length === 0) {
          PerformanceStore.setLoaderStatus("getFirstDeri", "success");
          PerformanceStore.loaderCloseFunction();
          this.portfolioTabsStatus.derivatives = true;
        }
        this.getDerivativesData({ signal });
      },
      onFail: (error) => {
        PerformanceStore.loaderCloseOnFail();
      },
      signal,
    });
  }

  setSubAssettabs(data) {
    this.subAssettabs = data;
  }

  setInfinityInstrumentIds(data) {
    this.selectedInfinityInstrument = data;
  }

  checkOffshoreSubAssetApiStatus({ loader, currentDataPoint }) {
    if (
      !Object.values(this.offshoreSubAssetApiFetchStatus).includes("pending")
    ) {
      this[loader] = false;
      this[currentDataPoint] = false;
    }
  }

  getPortfolioAssetClasses = ({ familyId, measureId, signal }) => {
    if (this.getData === "fam") {
      return getFamiliesPortfolioAssetClasses(
        familyId,
        this.getDataWithNuvamaOrOther,
        {
          isLive: this.isLive,
          isInfinity: this.isInfinity,
          mesurementId: measureId,
          signal,
        },
      );
    } else
      return getClientPortfolioAssetClass(
        this.userData.user_id || getCookie("userid"),
        this.getDataWithNuvamaOrOther,
        {
          isLive: this.isLive,
          isInfinity: this.isInfinity,
          mesurementId: measureId,
          signal,
        },
      );
  };
  // on tab change on sub asset page portfolio
  getVehicleDetails(
    { assetClassId, vehicleId, measureId, isInfinity, signal },
    loader,
  ) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    if (!this.callingLiveApi)
      this.setPortfolioLoader(
        isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
        "pending",
      );
    vehicleDetails({
      isFamily: this.getData === "fam" ? "families" : "clients",
      id: this.getData === "fam" ? familyId : userId,
      assetClassId,
      vehicleId,
      params: {
        isInfinity: this.isInfinity,
        advisor: this.getDataWithNuvamaOrOther,
        isLive: this.isLive,
        MeasureInstrumentId: measureId,
        signal,
      },
    })
      .then(({ data }) => {
        this.vehicleDataLength = data.length;
        let modifiedLocalData = data.map((vehicle) => {
          if (this.selectedInstrumentVehicle.vehicleId === 79) {
            return returnModifiedData(vehicle);
          } else if (vehicle.instrument.isInfinityProduct === null) {
            return returnModifiedData(vehicle);
          } else return undefined;
        });

        this.updateModifiedData(
          this.selectedInstrumentVehicle.modifiedVehicleData,
        );
        this.updateRememberedModifiedData(
          this.selectedInstrumentVehicle.modifiedVehicleData,
        );

        if (this.isInfinity === "0" && this.isLive === "0") {
          this.setForNoInfinitySubAssetData(this.selectedInstrumentVehicle);
        }
        let newModifiedData = [];
        if (
          this.selectedInstrumentVehicle.vehicleId === 18 ||
          this.selectedInstrumentVehicle.vehicleId === 14
        ) {
          newModifiedData = data.map((vehicle) => {
            if (vehicle.instrument.isInfinityProduct === "1") {
              return returnModifiedData(vehicle);
            } else return undefined;
          });

          this.updateModifiedInfinityData(newModifiedData);
        }

        let newAssetdData = this.assetdData;

        newAssetdData.forEach((eachAssetData) => {
          if (eachAssetData?.assetId == assetClassId) {
            eachAssetData.allSubAssetDetails?.forEach((eachSubClass) => {
              if (eachSubClass.id == vehicleId) {
                let newObj = {
                  ...eachSubClass?.subAssetData[0],
                  modifiedVehicleData: modifiedLocalData?.filter(
                    (eachData) => eachData,
                  ),

                  modifiedInfinityInstrument: newModifiedData?.filter(
                    (eachData) => eachData,
                  ),
                };
                eachSubClass.subAssetData[0] = newObj;
                this.selectedInstrumentVehicle = {
                  ...this.selectedInstrumentVehicle,
                  ...newObj,
                };
              }
            });
          }
        });

        this.assetdData = newAssetdData;
        AuthStore.updateLoadingFullScreen(false);
        this.setPortfolioLoader(
          isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
          "success",
        );
        this.setCallingSubAssetApi(false);
      })
      .catch(() => {
        this.setPortfolioLoader(
          isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
          "failed",
        );
        AuthStore.updateLoadingFullScreen(false);
        this.setCallingSubAssetApi(false);
      });
    return;
  }

  setPortfolioPathOnApiCall({
    assetClassId,
    vehicleId,
    assetClassName,
    vehicleName,
  }) {
    let show = !assetClassName
      ? `${getAssetClasses(assetClassId)}-${getSubAssetClasses(vehicleId)}`
      : `${assetClassName}-${vehicleName}`;
    this.setPortfolioPath([
      {
        path: "/portfolio",
        show: "Portfolio",
        state: {
          open: Number(assetClassId),
          from: "portfolio",
        },
      },
      {
        path: `/portfolio/subassetclassdetails/${assetClassId}/${vehicleId}`,
        show,
        state: { from: "portfolio" },
      },
    ]);
  }

  onToggleLive({ assetClassId, vehicleId, measureId, isInfinity, signal }) {
    const familyId = this.userData.family_id || getCookie("famid");
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);

    this.setPortfolioLoader(
      isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
      "pending",
    );
    const assetData = this.assetdData;
    if (
      !assetData.length ||
      assetData[0].assetId === 0 ||
      this.isInfinity === "1"
    ) {
      this.getPortfolioAssetClasses({ familyId, measureId, signal })
        .then(({ data }) => {
          // if data is empty
          if (
            this.isInfinity !== "1" &&
            (!data.length || (data.length === 1 && data[0].id === 0))
          ) {
            this.setPortfolioPathOnApiCall({
              assetClassId,
              vehicleId,
            });
          }

          if (data.length && data[0].id !== 0) {
            let newData = data;
            let rowData = newData?.filter(
              (eachData) => String(eachData?.id) == assetClassId,
            );

            this.setAssetTabsData(newData, true);
            let vehiclList = [];

            if (rowData[0]) {
              vehiclList = rowData[0]?.instrumentVehiclesList?.filter(
                (eachRow) => String(eachRow?.id) == vehicleId,
              );
            }

            if (!rowData[0]) {
              rowData[0] = newData[0];
              vehiclList[0] = rowData[0]?.instrumentVehiclesList?.[0];
            }
            if (!vehiclList[0]) {
              vehiclList[0] = rowData[0]?.instrumentVehiclesList?.[0];
            }
            // check this
            this.setSubAssetFirstVehicleListIds({
              assetId: rowData?.[0]?.id,
              subAssetId: vehiclList?.[0]?.id,
            });

            if (!vehiclList[0]) {
              this.setPortfolioLoader(
                isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
                "success",
              );
              this.isNoDataSubAssetLevel = true;
              this.isNoAssetClassPresent = true;
            } else {
              this.isNoDataSubAssetLevel = false;
              this.isNoAssetClassPresent = false;
            }

            if (!this.isNoDataSubAssetLevel) {
              this.setSubAssetName(vehiclList[0]?.assetClass?.name);
              const vehicleData = vehiclList[0]?.investmentreturn;
              if (
                Number(vehicleData?.current_value?.actual_value) == 0 &&
                Number(vehicleData?.invested_value?.actual_value) == 0 &&
                Number(vehicleData?.unrealised_gain?.amount?.actual_value) ==
                  0 &&
                Number(vehicleData?.int_div?.amount?.actual_value) == 0 &&
                Number(vehicleData?.realised_gain?.amount?.actual_value) == 0
              ) {
                this.setPortfolioLoader(
                  isInfinity === "0"
                    ? "portfolioSubLoader"
                    : "infinitySubLoader",
                  "success",
                );
                this.isNoDataSubAssetLevel = true;
              } else {
                this.isNoDataSubAssetLevel = false;
              }
              this.setSelectedInstrumentVehicle({
                assetClassId: rowData[0].id,
                vehicleId: vehiclList[0].id,
                assetClassData: rowData[0],
                vehicleData: vehiclList[0],
              });

              if (this.isInfinity !== "1") {
                // check
                this.setPortfolioPathOnApiCall({
                  assetClassId,
                  vehicleId,
                  assetClassName: rowData?.[0]?.assetClass?.name,
                  vehicleName: vehiclList?.[0]?.assetClass?.name,
                });
              }

              this.getVehicleDetails(
                {
                  assetClassId: rowData[0].id,
                  vehicleId: vehiclList[0].id,
                  measureId,
                  isInfinity,
                  signal,
                },
                "noLoader",
              );
            } else {
              AuthStore.updateLoadingFullScreen(false);
              if (this.isInfinity !== "1") {
                this.setPortfolioPathOnApiCall({
                  assetClassId,
                  vehicleId,
                });
              }
            }
          } else {
            this.isNoDataSubAssetLevel = true;
            this.isNoAssetClassPresent = true;
            this.setPortfolioLoader(
              isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
              "success",
            );
            this.setSelectedInstrumentVehicle({
              assetClassId: assetClassId,
              vehicleId: vehicleId,
            });
          }
        })
        .catch((error) => {
          AuthStore.updateLoadingFullScreen(
            error.config?.signal?.aborted ? true : false,
          );
          this.setPortfolioLoader(
            isInfinity === "0" ? "portfolioSubLoader" : "infinitySubLoader",
            "failed",
          );
          PerformanceStore.loaderCloseOnFail();
        });
    } else {
      const toFilterData =
        this.isInfinity === "0"
          ? this.portfolio.clientAssetClass
          : this.portfolio.clientAssetClassInfinity;
      let rowData = toFilterData?.filter(
        (eachData) => String(eachData?.id) == assetClassId,
      );

      let vehiclList = [];

      if (rowData[0]) {
        vehiclList = rowData[0]?.instrumentVehiclesList?.filter(
          (eachRow) => String(eachRow?.id) == vehicleId,
        );
      }

      this.setSelectedInstrumentVehicle({
        assetClassId: rowData[0].id,
        vehicleId: vehiclList[0].id,
        assetClassData: rowData[0],
        vehicleData: vehiclList[0],
      });

      this.setSubAssetFirstVehicleListIds({
        assetId: rowData?.[0]?.id,
        subAssetId: vehiclList?.[0]?.id,
      });

      this.getVehicleDetails(
        {
          assetClassId: rowData[0].id,
          vehicleId: vehiclList[0].id,
          measureId,
          isInfinity,
          signal,
        },
        "noLoader",
      );
    }
  }

  // to get live values for direct equity sub asset class
  getLiveValues({ assetClassId, vehicleId, signal }) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    if (!this.callingLiveApi)
      this.setPortfolioLoader("portfolioSubLoader", "pending");

    this.getPortfolioAssetClasses({ familyId, measureId: "", signal })
      .then(({ data }) => {
        let rowData = data;

        let selectedVehicle = rowData[0].instrumentVehiclesList?.filter(
          (eachVehicle) => String(eachVehicle.id) == vehicleId,
        );

        const allAssetData = [...this.assetdData];
        allAssetData[0].allSubAssetDetails[0].subAssetData[0] = {
          ...allAssetData[0].allSubAssetDetails[0].subAssetData[0],
          assetClassData: rowData[0],
          vehicleData: selectedVehicle[0],
        };
        this.assetdData = allAssetData;
        this.setSelectedInstrumentVehicle({
          assetClassId: rowData[0].id,
          vehicleId: selectedVehicle[0].id,
          assetClassData: rowData[0],
          vehicleData: selectedVehicle[0],
        });
        this.setCallingLiveApi({
          ...this.callingLiveApi,
          tileDataLoading: false,
        });
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
        this.setCallingLiveApi({
          ...this.callingLiveApi,
          tileDataLoading: false,
        });
        this.setPortfolioLoader("portfolioSubLoader", "pending");
      });

    vehicleDetails({
      isFamily: this.getData === "fam" ? "families" : "clients",
      id: this.getData === "fam" ? familyId : userId,
      assetClassId,
      vehicleId,
      params: {
        isInfinity: this.isInfinity,
        advisor: this.getDataWithNuvamaOrOther,
        isLive: this.isLive,
        signal,
      },
    })
      .then(({ data: vehiclesData }) => {
        let modifiedLocalData = vehiclesData.map((vehicle) => {
          return returnModifiedData(vehicle);
        });

        const allAssetData = [...this.assetdData];
        allAssetData[0].allSubAssetDetails[0].subAssetData[0] = {
          ...allAssetData[0].allSubAssetDetails[0].subAssetData[0],
          modifiedVehicleData: modifiedLocalData,
        };

        this.assetdData = allAssetData;
        this.setSelectedInstrumentVehicle({
          ...this.selectedInstrumentVehicle,
          modifiedVehicleData: modifiedLocalData.filter((eachData) => eachData),
        });

        this.updateModifiedData(modifiedLocalData);
        this.setCallingLiveApi({
          ...this.callingLiveApi,
          tableDataLoading: false,
        });
        this.setPortfolioLoader("portfolioSubLoader", "success");
      })

      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
        this.setCallingLiveApi({
          ...this.callingLiveApi,
          tableDataLoading: false,
        });
        this.setPortfolioLoader("portfolioSubLoader", "failed");
      });
  }

  // on chnage of family member and global button
  onFilterChange({ signal }) {
    const familyId = this.userData.family_id || getCookie("famid");
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);

    this.setPortfolioLoader("portfolioSubLoader", "pending");
    this.getPortfolioAssetClasses({ familyId, measureId: "", signal })
      .then(({ data }) => {
        let newData = data.length ? [...data] : [];

        this.setAssetTabsData(newData, true);

        let rowData = [];
        rowData.push(newData[0]);
        let vehiclList = [];
        if (rowData[0]) {
          vehiclList.push(rowData[0]?.instrumentVehiclesList[0]);
          this.setSubAssetFirstVehicleListIds({
            assetId: rowData?.[0]?.id,
            subAssetId: vehiclList?.[0]?.id,
          });
        }

        if (!vehiclList[0]) {
          this.setPortfolioLoader("portfolioSubLoader", "success");
          this.isNoDataSubAssetLevel = true;
          this.isNoAssetClassPresent = true;
        } else {
          this.isNoDataSubAssetLevel = false;
          this.isNoAssetClassPresent = false;
        }

        if (!this.isNoDataSubAssetLevel) {
          const vehicleData = vehiclList[0]?.investmentreturn;
          if (
            Number(vehicleData?.current_value?.actual_value) == 0 &&
            Number(vehicleData?.invested_value?.actual_value) == 0 &&
            Number(vehicleData?.unrealised_gain?.amount?.actual_value) == 0 &&
            Number(vehicleData?.int_div?.amount?.actual_value) == 0 &&
            Number(vehicleData?.realised_gain?.amount?.actual_value) == 0
          ) {
            this.isNoDataSubAssetLevel = true;
          } else {
            this.isNoDataSubAssetLevel = false;
          }
          this.setSelectedInstrumentVehicle({
            assetClassId: rowData[0].id,
            vehicleId: vehiclList[0].id,
            assetClassData: rowData[0],
            vehicleData: vehiclList[0],
          });

          this.getVehicleDetails(
            {
              assetClassId: rowData[0].id,
              vehicleId: vehiclList[0].id,
              measureId: "",
              isInfinity: this.isInfinity,
              signal,
            },
            "noLoader",
          );
        } else {
          AuthStore.updateLoadingFullScreen(false);
        }
      })
      .catch((error) => {
        this.setPortfolioLoader("portfolioSubLoader", "failed");
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
      });
  }

  setFilterStatus(data) {
    this.isNoDataSubAssetLevel = data;
    this.isNoAssetClassPresent = false;
  }

  setSubAssetFirstVehicleListIds({ assetId, subAssetId }) {
    this.subAssetFirstVehicleListIds = {
      assetId,
      subAssetId,
    };
  }

  getReportsPersistData() {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    if (this.getData === "fam") {
      this._getFamilyPortfolioReturn({
        userId: familyId,
        onSuccess: (data) => {
          this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);
        },
        onFail: (error) => {},
      });
      this._getFamilyPortfolio({
        userId: familyId,
        onSuccess: (data) => {
          this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
        },
        onFail: () => {},
      });
    } else {
      this._getClientPortfolioReturn({
        userId,
        onSuccess: (data) => {
          this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);
        },
        onFail: (error) => {},
      });
      this._getClientPortfolio({
        userId,
        onSuccess: (data) => {
          this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
        },
        onFail: () => {},
      });
    }
  }

  getInfiniyHoldsData({ isScroll, measureId }, signal) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");
    if (this.getData === "fam") {
      this._getFamilyPortfolioReturnInfinity({
        userId: familyId,
        signal,
        onSuccess: (data) => {
          this.othersInfinityHolding.investmentreturn.current_value.actual_value =
            this.infinityHoldingData?.investmentreturn?.current_value
              ?.actual_value - data?.current_value?.actual_value;

          PerformanceStore.setLoaderStatus("infinityReturns", "success");
          PerformanceStore.loaderCloseFunction();
        },
        onFail: (error) => {
          PerformanceStore.loaderCloseOnFail();
        },
        measureId,
      });
    } else {
      this._getClientPortfolioReturnInfinity({
        userId,
        signal,
        onSuccess: (data) => {
          this.othersInfinityHolding.investmentreturn.current_value.actual_value =
            this.infinityHoldingData?.investmentreturn?.current_value
              ?.actual_value - data?.current_value?.actual_value;

          PerformanceStore.setLoaderStatus("infinityReturnsClient", "success");
          PerformanceStore.loaderCloseFunction();
        },
        onFail: (error) => {
          PerformanceStore.loaderCloseOnFail();
        },
        measureId,
      });
    }
  }

  populateInfinityPortfolio(measureId, isLoaded, signal) {
    const familyId = this.userData.family_id || getCookie("famid");

    PerformanceStore.setLoaderStatus(
      "getFamiliesPortfolioAssetClasses",
      "pending",
    );
    this.getInfinityReturns(measureId, signal);
    if (this.getData === "fam") {
      getFamiliesPortfolioAssetClasses(
        familyId,
        this.getDataWithNuvamaOrOther,
        {
          isLive: this.isLive,
          isInfinity: this.isInfinity,
          mesurementId: measureId,
          signal,
        },
      )
        .then(({ data }) => {
          this.setIsInfinityPopulated(true);
          this.excelAssetClassesDataInfinity = data.map(
            this.getDataInExcelFormat,
          );
          const newData = data;
          if (this.isInfinity === "1") {
            newData.push(this.othersInfinityHolding);
          }

          this.addToPortfolio({
            clientAssetClassInfinity: this.isInfinity !== "1" ? data : newData,
            allocationSummaryInfinity: data.map((item) => {
              return {
                value: item.allocation_percentage,
                toolTipLabel: item.assetClass?.name,
                id: item.id,
              };
            }),
          });

          PerformanceStore.setLoaderStatus(
            "getFamiliesPortfolioAssetClasses",
            "success",
          );
          PerformanceStore.loaderCloseFunction();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
        });
    } else {
      getClientPortfolioAssetClass(
        this.userData.user_id || getCookie("userid"),
        this.getDataWithNuvamaOrOther,
        {
          isLive: this.isLive,
          isInfinity: this.isInfinity,
          mesurementId: measureId,
          signal,
        },
      )
        .then(({ data }) => {
          this.setIsInfinityPopulated(true);
          this.excelAssetClassesDataInfinity = data.map(
            this.getDataInExcelFormat,
          );
          const newData = data;
          if (this.isInfinity === "1") {
            newData.push(this.othersInfinityHolding);
          }
          this.addToPortfolio({
            clientAssetClassInfinity: this.isInfinity !== "1" ? data : newData,
            allocationSummaryInfinity: data.map((item) => {
              return {
                value: item.allocation_percentage,
                toolTipLabel: item.assetClass?.name,
                id: item.id,
              };
            }),
          });

          PerformanceStore.setLoaderStatus(
            "getFamiliesPortfolioAssetClasses",
            "success",
          );
          PerformanceStore.loaderCloseFunction();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
        });
    }
  }

  checkFinancialApisStatus() {
    const wholeStatus = Object.keys(this.financialApiStatus);
    const wholeValues = Object.values(this.financialApiStatus);
    let i = null;
    for (i = 0; i < 6; i++) {
      if (this.financialApiStatus[wholeStatus[i]] === "pending") {
        break;
      }
    }
    if (wholeValues.includes("failure")) {
      this.portfolioTabsStatus.financial = false;
      // !wholeValues.includes("pending")
    } else if (i === 6) {
      this.portfolioTabsStatus.financial = true;
    }
  }

  checkOffshoreApisStatus(apiList, loader) {
    const allAPIStatus = Object.values(this[apiList]);
    if (allAPIStatus.includes("failed")) {
      this.portfolioTabsStatus.offshore = false;
      if (!allAPIStatus.includes("pending")) {
        this[loader] = false;
      }
    } else if (!allAPIStatus.includes("pending")) {
      this.portfolioTabsStatus.offshore = true;
      this[loader] = false;
    }
  }

  setFamilyViewData(data) {
    const getTileData = (tileData) => {
      return {
        id: tileData.subAssetClassID,
        assetClass: {
          id: tileData.subAssetClassID,
          name: tileData.subAssetClass,
        },
        allocation_percentage: tileData.perAllocationToPortfolio,
        investmentreturn: {
          as_of_date: null,
          current_value: tileData.currentValue,
          invested_value: tileData.investmentValue,
          int_div: {
            amount: tileData.interestDividend,
          },
          unrealised_gain: {
            amount: tileData.unRealisedGainLoss,
            percentage: tileData.percentage_unrealised || null,
          },
          realised_gain: {
            amount: tileData.realisedGainLoss,
          },
          irr: tileData.returnITDPer,
        },
      };
    };

    let familyViewData = [];
    data.portfolioFamilyViewList.forEach((element) => {
      let internalMappedData = [];
      data.portfolioFamilyViewList.forEach((innerElement) => {
        if (innerElement.parentClassID === element.subAssetClassID) {
          internalMappedData.push(getTileData(innerElement));
        }
      });

      if (element.parentClassID === 0) {
        familyViewData.push({
          ...getTileData(element),
          instrumentVehiclesList: internalMappedData,
        });
      }
    });

    return familyViewData;
  }

  sortGraph({ data }) {
    // if data array have length then sort array based on ascending order of date
    let sortedData = [];
    if (data && data.length) {
      sortedData = data?.sort((a, b) => new Date(a?.date) - new Date(b?.date));
    }
    return sortedData;
  }

  populatePortfolio({ isScroll, measureId, signal }, infinity) {
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");

    this.financialApiStatus = {
      familyPortfolioReturn: "pending",
      familyPortfolio: "pending",
      assetClass: "pending",
      subAssetClass: "pending",
      returnsLine: "pending",
      QuickViews: "pending",
      familyView: "pending",
    };

    if (this.getData === "fam") {
      this._getFamilyView({
        user_id: userId,
        advisor: this.getDataWithNuvamaOrOther,
        onSuccess: (data) => {
          this.familyViewData = this.setFamilyViewData(data);
          this.excelAssetDataFamily = this.familyViewData.map(
            this.getDataInExcelFormat,
          );
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.familyView = "success";
          this.checkFinancialApisStatus();
        },
        onFail: (error) => {
          PerformanceStore.loaderCloseOnFail();
          this.financialApiStatus.familyView = "failure";
          this.checkFinancialApisStatus();
        },
        signal,
      });
      PerformanceStore.setLoaderStatus(
        "_getFamilyPortfolioReturnHome",
        "pending",
      );
      this._getFamilyPortfolioReturn({
        userId: familyId,
        onSuccess: (data) => {
          this.addToPortfolio({ clientPortfolioReturn: data });
          this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);
          PerformanceStore.setLoaderStatus(
            "_getFamilyPortfolioReturnHome",
            "success",
          );
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.familyPortfolioReturn = "success";
          this.checkFinancialApisStatus();
        },
        onFail: (error) => {
          PerformanceStore.loaderCloseOnFail();
          this.financialApiStatus.familyPortfolioReturn = "failure";
          this.checkFinancialApisStatus();
        },
        signal,
      });

      this._getFamilyPortfolio({
        userId: familyId,
        onSuccess: (data) => {
          this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
          this.financialApiStatus.familyPortfolio = "success";
          this.checkFinancialApisStatus();
        },
        onFail: (error) => {
          this.financialApiStatus.familyPortfolio = "failure";
          this.checkFinancialApisStatus();
        },
        signal,
      });

      PerformanceStore.setLoaderStatus(
        "getFamiliesPortfolioAssetClasses",
        "pending",
      );
      getFamiliesPortfolioAssetClasses(
        familyId,
        this.getDataWithNuvamaOrOther,
        {
          isLive: this.isLive,
          isInfinity: this.isInfinity,
          mesurementId: measureId,
          signal,
        },
      )
        .then(({ data }) => {
          this.excelAssetClassesData = data.map(this.getDataInExcelFormat);
          const newData = data;
          if (this.isInfinity === "1") {
            newData.push(this.othersInfinityHolding);
          }

          this.addToPortfolio({
            clientAssetClass: this.isInfinity !== "1" ? data : newData,
            allocationSummary: data.map((item) => {
              return {
                value: item.allocation_percentage,
                toolTipLabel: item.assetClass?.name,
                id: item.id,
              };
            }),
          });

          this.setAssetTabsData(newData, true);

          PerformanceStore.setLoaderStatus(
            "getFamiliesPortfolioAssetClasses",
            "success",
          );
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.assetClass = "success";
          this.checkFinancialApisStatus();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
          this.financialApiStatus.assetClass = "failure";
          this.checkFinancialApisStatus();
        });

      PerformanceStore.setLoaderStatus("clientGetSubAssetClass", "pending");
      this.callApis(
        `families/${familyId}/portfolioassetclasses?advisor=${this.getDataWithNuvamaOrOther}&isInfinity=${this.isInfinity}`,
        "clientGetSubAssetClass",
        (obj) => this.addToPortfolio(obj),
        isScroll,
      );

      PerformanceStore.setLoaderStatus("getreturnsline", "pending");
      getReturnsLine({ isFamily: "families", id: familyId, signal })
        .then(({ data }) => {
          let sortedData = this.sortGraph({ data });

          this.addToPortfolio({
            portfolioGraphSeries: sortedData?.map((item) =>
              parseFloat(item.amount.actual_value),
            ),
            portfolioShowAmount: sortedData?.map((item) =>
              parseFloat(item.amount.value),
            ),
            portfolioGraphDates: sortedData?.map((item) => item.date),
            portFolioUnits: sortedData?.map((item) => item.amount.value_type),
            sortedGraphData: sortedData,
          });
          PerformanceStore.setLoaderStatus("getreturnsline", "success");
          PerformanceStore.loaderCloseFunction();
          this.financialApiStatus.returnsLine = "success";
          this.checkFinancialApisStatus();
        })
        .catch((error) => {
          PerformanceStore.loaderCloseOnFail();
          this.financialApiStatus.returnsLine = "failure";
          this.checkFinancialApisStatus();
        });

      return;
    }

    this.updateUserStoreData("financialApiStatus", { familyView: "success" });

    PerformanceStore.setLoaderStatus(
      "_getClientPortfolioReturnHome",
      "pending",
    );

    this._getClientPortfolioReturn({
      userId,
      onSuccess: (data) => {
        this.addToPortfolio({ clientPortfolioReturn: data });
        this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);
        PerformanceStore.setLoaderStatus(
          "_getClientPortfolioReturnHome",
          "success",
        );
        PerformanceStore.loaderCloseFunction();
        this.financialApiStatus.familyPortfolioReturn = "success";
        this.checkFinancialApisStatus();
      },
      onFail: (error) => {
        PerformanceStore.loaderCloseOnFail();
        this.financialApiStatus.familyPortfolioReturn = "failure";
        this.checkFinancialApisStatus();
      },
      signal,
    });

    this._getClientPortfolio({
      userId,
      onSuccess: (data) => {
        this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
        this.financialApiStatus.familyPortfolio = "success";
        this.checkFinancialApisStatus();
      },
      onFail: (error) => {
        this.financialApiStatus.familyPortfolio = "failure";
        this.checkFinancialApisStatus();
      },
      signal,
    });

    PerformanceStore.setLoaderStatus("getportfolioasset", "pending");
    this.callApis(
      `clients/${userId}/portfolioassetclasses?advisor=${this.getDataWithNuvamaOrOther}&isInfinity=${this.isInfinity}`,
      "clientGetSubAssetClass",
      (obj) => this.addToPortfolio(obj),
    );

    PerformanceStore.setLoaderStatus("clientReturnLine", "pending");
    getReturnsLine({ isFamily: "clients", id: userId, signal })
      .then(({ data }) => {
        let sortedData = this.sortGraph({ data });

        this.addToPortfolio({
          portfolioGraphSeries: sortedData?.map((item) =>
            parseFloat(item.amount.actual_value),
          ),
          portfolioShowAmount: sortedData?.map((item) =>
            parseFloat(item.amount.value),
          ),
          portfolioGraphDates: sortedData?.map((item) => item.date),
          portFolioUnits: sortedData?.map((item) => item.amount.value_type),
          sortedGraphData: sortedData,
        });
        PerformanceStore.setLoaderStatus("clientReturnLine", "success");
        PerformanceStore.loaderCloseFunction();
        this.financialApiStatus.returnsLine = "success";
        this.checkFinancialApisStatus();
      })
      .catch((error) => {
        AuthStore.updateLoadingFullScreen(false);
        PerformanceStore.loaderCloseOnFail();
        this.financialApiStatus.returnsLine = "failure";
        this.checkFinancialApisStatus();
      });

    PerformanceStore.setLoaderStatus("getClientPortfolioAssetClass", "pending");
    getClientPortfolioAssetClass(
      this.userData.user_id || getCookie("userid"),
      this.getDataWithNuvamaOrOther,
      {
        isLive: this.isLive,
        isInfinity: this.isInfinity,
        mesurementId: measureId,
        signal,
      },
    )
      .then(({ data }) => {
        this.excelAssetClassesData = data?.map(this.getDataInExcelFormat);

        const newData = data;
        if (this.isInfinity === "1") {
          newData.push(this.othersInfinityHolding);
        }
        this.addToPortfolio({
          clientAssetClass: this.isInfinity !== "1" ? data : newData,
          allocationSummary: data.map((item) => {
            return {
              value: item.allocation_percentage,
              toolTipLabel: item.assetClass?.name,
              id: item.id,
            };
          }),
        });

        this.setAssetTabsData(newData, true);

        PerformanceStore.setLoaderStatus(
          "getClientPortfolioAssetClass",
          "success",
        );
        PerformanceStore.loaderCloseFunction();
        this.financialApiStatus.assetClass = "success";
        this.checkFinancialApisStatus();
      })
      .catch((error) => {
        PerformanceStore.loaderCloseOnFail();
        this.financialApiStatus.assetClass = "failure";
        this.checkFinancialApisStatus();
      });

    return;
  }

  setOffshoreApiStatus({ apiList, currentApi, apiStatus, loader }) {
    this.setUserStoreData(apiList, {
      ...this[apiList],
      [currentApi]: apiStatus,
    });
    this.checkOffshoreApisStatus(apiList, loader);
  }

  getOffshorePortfolioReturn({
    resourceApiPrefix,
    currency,
    signal,
    apiList,
    loader,
  }) {
    this._getUsersPortfolioReturn({
      apiPreFix: resourceApiPrefix,
      currency,
      onSuccess: (data) => {
        this.addToOffshoreData({ clientPortfolioReturn: data });
        // this.setAsOfDate(data?.as_of_date, data?.unrealised_gain); // check this
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersPortfolioReturn",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersPortfolioReturn",
          apiStatus: "failed",
          loader,
        });
      },
      signal,
    });
  }
  getOffshorePortfolio({ resourceApiPrefix, currency, signal, apiList }) {
    this._getUsersPortfolio({
      apiPreFix: resourceApiPrefix,
      currency,
      onSuccess: (data) => {
        //  this.setInfinityDataReport(data?.valuation?.infinity?.total_amount); // check this
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersPortfolio",
          apiStatus: "success",
        });
      },
      onFail: (error) => {
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersPortfolio",
          apiStatus: "failed",
        });
      },
      signal,
    });
  }
  getOffshorePortfolioAssetClasses({
    resourceApiPrefix,
    currency,
    signal,
    apiList,
    loader,
  }) {
    this._getUsersPortfolioAssetClasses({
      apiPreFix: resourceApiPrefix,
      currency,
      onSuccess: (data) => {
        this.addToOffshoreData({
          downloadFileData: data.map(this.getDataInExcelFormat),
        });

        this.addToOffshoreData({
          clientAssetClass: data,
          allocationSummary: data.map((item) => {
            return {
              value: item.allocation_percentage,
              toolTipLabel: item.assetClass?.name,
              id: item.id,
            };
          }),
        });

        // const assetClassTabs = getOffshoreSubAssetTabs({ data });

        // this.addToOffshoreData({ assetClassTabs });

        // const subAssetData = getSubAssetCurrencyData({
        //   currencyData: this.currencyData,
        //   assetClassTabs,
        //   currency,
        //   allAssetClassData: data,
        // });

        // this.setUserStoreData("subAssetCurrencyData", subAssetData);

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersPortfolioAssetClasses",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.addToOffshoreData({
          downloadFileData: [],
        });

        this.addToOffshoreData({
          clientAssetClass: [],
          allocationSummary: [],
        });

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersPortfolioAssetClasses",
          apiStatus: "failed",
          loader,
        });
      },
      meta: {
        signal,
        isLive: this.isLive,
        isInfinity: this.isInfinity,
        currency,
      },
    });
  }
  getOffshoreSubAssetClasses({
    resourceApiPrefix,
    currency,
    signal,
    apiList,
    loader,
  }) {
    // check scroll
    this._getUsersSubAssetClasses({
      apiPreFix: resourceApiPrefix,
      onSuccess: (data) => {
        this.addToOffshoreData({ clientGetSubAssetClass: data });

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersSubAssetClasses",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersSubAssetClasses",
          apiStatus: "failed",
          loader,
        });
      },
      meta: {
        signal,
        isInfinity: this.isInfinity,
        currency,
      },
    });
  }
  getOffshoreReturnsLine({
    resourceApiPrefix,
    currency,
    signal,
    apiList,
    loader,
  }) {
    this._getUsersReturnsLine({
      apiPreFix: resourceApiPrefix,
      onSuccess: (data) => {
        let sortedData = this.sortGraph({ data });

        this.addToOffshoreData({
          portfolioGraphSeries: sortedData?.map((item) =>
            parseFloat(item.amount.actual_value),
          ),
          portfolioShowAmount: sortedData?.map((item) =>
            parseFloat(item.amount.value),
          ),
          portfolioGraphDates: sortedData?.map((item) => item.date),
          portFolioUnits: sortedData?.map((item) => item.amount.value_type),
        });

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersReturnsLine",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersReturnsLine",
          apiStatus: "failed",
          loader,
        });
      },
      meta: {
        signal,
        currency,
      },
    });
  }

  getPortfolioReturnData({ resourceApiPrefix, signal, apiList, loader }) {
    this._getPortfolioReturn({
      apiPreFix: resourceApiPrefix,
      onSuccess: (data) => {
        this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getPortfolioReturnData",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getPortfolioReturnData",
          apiStatus: "failed",
          loader,
        });
      },
      signal,
    });
  }

  getPortfolioData({ resourceApiPrefix, signal, apiList, loader }) {
    this._getPortfolio({
      apiPreFix: resourceApiPrefix,
      onSuccess: (data) => {
        this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
        this.setUserStoreData(apiList, {
          ...this[apiList],
          getUsersPortfolio: "success",
        });
        this.checkOffshoreApisStatus(apiList);

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getPortfolioData",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.setUserStoreData(apiList, {
          ...this[apiList],
          getUsersPortfolio: "failed",
        });
        this.checkOffshoreApisStatus(apiList);
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getPortfolioData",
          apiStatus: "failed",
          loader,
        });
      },
      signal,
    });
  }

  setLiaisonOfficerData({ userId, onSuccess, onFail }) {
    SettingsStore.getLaisonOfficersData({
      clientId: userId,
      onSuccess: (data) => {
        const imageArr = {};
        if (data[0].profile.profile_pic) {
          SettingsStore.getImageFromAPI({
            path: data[0].profile.profile_pic,
            onSuccess: (imageRawData) => {
              getBlobToBase64(imageRawData).then((url) => {
                let resImage = url;
                imageArr[data[0].profile.user_id] = resImage;
                SettingsStore.profile = {
                  name: data[0].profile.profile_pic.slice(
                    data[0].profile.profile_pic.lastIndexOf("/") + 1,
                  ),
                  size: getFileSize(imageRawData?.size),
                  exactSize: imageRawData?.size,
                  type: imageRawData?.type,
                  src: resImage,
                  file: imageRawData,
                };
                SettingsStore.liaisonOfficerImages = {
                  ...SettingsStore.liaisonOfficerImages,
                  ...imageArr,
                };
              });
            },
          });
        }
        SettingsStore.liaisonOfficerData = data[0];
        onSuccess(data);
      },
      onFail: (error) => {
        onFail(error);
      },
      loader: true,
    });
  }

  populateOffshorePortfolio({ isScroll, signal }) {
    const {
      user_type,
      userId,
      primary,
      isOffshoreOnly,
      resourceId,
      resourceApi,
    } = getUserDataForAPIs({ userData: this.userData, getData: this.getData });

    const { resourceApiPrefix } = resourceApi;

    const apiList = "offshoreApiStatus";
    PerformanceStore.loaderCloseOnFail();
    const loader = "isOffshoreAssetPageLoading";
    this.setUserStoreData(loader, true);
    this.setUserStoreData(apiList, deafaultOffshoreApiStatus);

    const successState = {
      apiList,
      apiStatus: "success",
    };

    const failedState = {
      apiList,
      apiStatus: "failed",
    };

    // Update given APIs fetching status to success
    function getSuccessStatus({ api }) {
      return { ...successState, currentApi: api };
    }

    // Update given APIs fetching status to fail
    function getFailStatus({ api }) {
      return { ...failedState, currentApi: api };
    }

    // Fetch currency data first
    // If currency fetch succeeds then call other APIs of required data
    // Else do not call other APIs and display error screen
    this._getUsersCurrency({
      params: resourceId,
      signal,
      onSuccess: (data) => {
        this.setUserStoreData(
          "currencyData",
          dataIsArray(data) ? getUniqueCurrencies({ data }) : [],
        );

        this.setUserStoreData(
          "offshoreSubAssetPageTabs",
          getAssetsClassTabsData({ data }),
        );

        const currency = data[0]?.currency;

        const endpointData = {
          resourceApiPrefix,
          currency,
          signal,
          apiList,
          loader,
        };
        this.getOffshorePortfolioReturn(endpointData);
        //this.getOffshorePortfolio(endpointData);
        this.getOffshorePortfolioAssetClasses(endpointData);
        this.getOffshoreSubAssetClasses(endpointData);
        this.getOffshoreReturnsLine(endpointData);

        // if (this.getData === "fam") {

        //   this._getUsersFamilyView({
        //     user_id: userId,
        //     currency,
        //     advisor: this.getDataWithNuvamaOrOther,
        //     onSuccess: (data) => {
        //       this.addToOffshoreData({
        //         familyViewData: this.setFamilyViewData(data),
        //       });

        //       this.addToOffshoreData({
        //         downloadFamilyViewFileData: this.familyViewData.map(
        //           this.getDataInExcelFormat,
        //         ),
        //       });

        //       // this.familyViewData = this.setFamilyViewData(data);
        //       // this.excelAssetDataFamily = this.familyViewData.map(
        //       //   this.getDataInExcelFormat
        //       // );

        //       this.setOffshoreApiStatus({
        //         ...getSuccessStatus({ api: "getFamilyView" }),
        //         loader,
        //       });
        //     },
        //     onFail: (error) => {
        //       this.setOffshoreApiStatus({
        //         ...getFailStatus({ api: "getFamilyView" }),
        //         loader,
        //       });
        //     },
        //     signal,
        //   });
        // } else {
        //   this.setOffshoreApiStatus({
        //     ...getSuccessStatus({ api: "getFamilyView" }),
        //     loader,
        //   });
        // }

        this.setOffshoreApiStatus({
          ...getSuccessStatus({ api: "getFamilyView" }),
          loader,
        });

        this.setOffshoreApiStatus({
          ...getSuccessStatus({ api: "getUsersCurrency" }),
          loader,
        });
      },
      onFail: (error) => {
        this.setUserStoreData("currencyData", []);

        this.setUserStoreData("offshoreSubAssetPageTabs", []);
        this.setOffshoreApiStatus({
          ...getFailStatus({ api: "getUsersCurrency" }),
          loader: "isOffshoreAssetPageLoading",
        });
        this.setUserStoreData("isOffshoreAssetPageLoading", false);
      },
    });

    // If selected family or client is having only global investment then we skip home page and portfolio page becomes the landing page after login/family or clien selection
    // Then we set the required thing in portfolio as we set it in home page and call other required APIs
    if (isOffshoreOnly) {
      const isPrimaryCustomerLogin =
        user_type === "customer" && primary !== "false";

      this.getPointOfConnect({
        onSuccess: (data) => {
          this.setConnectData(data);
          this.exportDetails = data;
          this.setOffshoreApiStatus({
            ...getSuccessStatus({ api: "getConnectData" }),
            loader,
          });
        },
        onFail: (error) => {
          this.setConnectData([]);
          this.setOffshoreApiStatus({
            ...getFailStatus({ api: "getConnectData" }),
            loader,
          });
        },
      });
      ReportsStore.getprofile({
        userId,
        onSuccess: (data) => {
          this.setOffshoreApiStatus({
            ...getSuccessStatus({ api: "getProfile" }),
            loader,
          });
        },
        onFail: (error) => {
          this.setOffshoreApiStatus({
            ...getFailStatus({ api: "getProfile" }),
            loader,
          });
        },
      });
      this.getFamilyClients(
        "forImg",
        () => {
          this.setOffshoreApiStatus({
            ...getSuccessStatus({ api: "getFamilyData" }),
            loader,
          });
        },
        () => {
          this.setUserStoreData("currentFamilyMembers", []);
          this.setOffshoreApiStatus({
            ...getFailStatus({ api: "getFamilyData" }),
            loader,
          });
        },
        signal,
      );
      this.getPortfolioReturnData({
        resourceApiPrefix,
        signal,
        apiList,
        loader,
      });
      this.getPortfolioData({ resourceApiPrefix, signal, apiList, loader });

      if (user_type !== "employee") {
        if (isPrimaryCustomerLogin) {
          if (
            !SettingsStore.familyMemberAccessData ||
            !SettingsStore.settingsOptionsArr
          ) {
            SettingsStore.callGetFamilyMemberAccessData({
              onDataSuccess: (data) => {
                this.setOffshoreApiStatus({
                  ...getSuccessStatus({ api: "getSettingsData" }),
                  loader,
                });
              },
              onDataFail: (error) => {
                this.setOffshoreApiStatus({
                  ...getFailStatus({ api: "getSettingsData" }),
                  loader,
                });
              },
            }); // pending
          } else {
            this.setOffshoreApiStatus({
              ...getSuccessStatus({ api: "getSettingsData" }),
              loader,
            });
          }
        } else if (!SettingsStore.settingsOptionsArr) {
          SettingsStore.updateSettingsOptionsArr(
            allUsersSetting[
              user_type === MANAGER ? MANAGER : NON_PRIMARY_CUSTOMER
            ],
          );
          this.setOffshoreApiStatus({
            ...getSuccessStatus({ api: "getSettingsData" }),
            loader,
          });
        } else if (SettingsStore.settingsOptionsArr) {
          this.setOffshoreApiStatus({
            ...getSuccessStatus({ api: "getSettingsData" }),
            loader,
          });
        }
      } else {
        this.setOffshoreApiStatus({
          ...getSuccessStatus({ api: "getSettingsData" }),
          loader,
        });
      }

      if (user_type === MANAGER) {
        this.setLiaisonOfficerData({
          userId,
          onSuccess: (data) => {
            this.setOffshoreApiStatus({
              ...getSuccessStatus({ api: "getLiasionData" }),
              loader,
            });
          },
          onFail: (error) => {
            this.setOffshoreApiStatus({
              ...getFailStatus({ api: "getLiasionData" }),
              loader,
            });
          },
        });
      } else {
        this.setOffshoreApiStatus({
          ...getSuccessStatus({ api: "getLiasionData" }),
          loader,
        });
      }
    } else {
      this.updateUserStoreData(apiList, {
        getSettingsData: "success",
        getLiasionData: "success",
        getConnectData: "success",
        getProfile: "success",
        getFamilyData: "success",
        getPortfolioReturnData: "success",
        getPortfolioData: "success",
      });
    }
  }

  getOffshoreTabData({ currency, tabRef }) {
    // This function is called when new currency is selected from the currency drop down
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    const { resourceApiPrefix } = resourceApi;

    const apiList = "offshoreApiStatus";
    const loader = "isOffshoreAssetDataLoading";
    PerformanceStore.loaderCloseOnFail();
    this.setUserStoreData(apiList, deafaultOffshoreApiStatus);
    this.setUserStoreData(loader, true);

    const endpointData = {
      resourceApiPrefix,
      currency,
      signal: tabRef.signal,
      apiList,
      loader,
    };

    this.updateUserStoreData(apiList, {
      getUsersCurrency: "success",
      getSettingsData: "success",
      getLiasionData: "success",
      getConnectData: "success",
      getProfile: "success",
      getFamilyData: "success",
      getPortfolioReturnData: "success",
      getPortfolioData: "success",
    });

    this.getOffshorePortfolioReturn(endpointData);
    // this.getOffshorePortfolio(endpointData);
    this.getOffshorePortfolioAssetClasses(endpointData);
    this.getOffshoreSubAssetClasses(endpointData);
    this.getOffshoreReturnsLine(endpointData);

    // if (this.getData === "fam") {
    //
    // get userId from getUserDataForAPIs() function
    //   this._getUsersFamilyView({
    //     user_id: userId,
    //     currency,
    //     advisor: this.getDataWithNuvamaOrOther,
    //     onSuccess: (data) => {
    //       this.addToOffshoreData({
    //         familyViewData: this.setFamilyViewData(data),
    //       });

    //       this.addToOffshoreData({
    //         downloadFamilyViewFileData: this.familyViewData.map(
    //           this.getDataInExcelFormat,
    //         ),
    //       });
    //       // this.familyViewData = this.setFamilyViewData(data);
    //       // this.excelAssetDataFamily = this.familyViewData.map(
    //       //   this.getDataInExcelFormat
    //       // );

    //       this.setOffshoreApiStatus({
    //         apiList,
    //         currentApi: "getFamilyView",
    //         apiStatus: "success",
    //         loader,
    //       });
    //     },
    //     onFail: (error) => {
    //       this.setOffshoreApiStatus({
    //         apiList,
    //         currentApi: "getFamilyView",
    //         apiStatus: "failed",
    //         loader,
    //       });
    //     },
    //     signal: tabRef?.signal,
    //   });
    // } else {
    //   this.setOffshoreApiStatus({
    //     apiList,
    //     currentApi: "getFamilyView",
    //     apiStatus: "success",
    //     loader,
    //   });
    // }

    this.setOffshoreApiStatus({
      apiList,
      currentApi: "getFamilyView",
      apiStatus: "success",
      loader,
    });
  }

  getOffshoreDataOnFamilyMemberChange({ isScroll, signal }) {
    // This function is called when global investment held with filter is changed or global tab from domestic or global is selected in portfolio page
    const { resourceApi, resourceId } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    const { resourceApiPrefix } = resourceApi;

    const apiList = "offshoreApiStatus";
    PerformanceStore.loaderCloseOnFail();
    const loader = "isOffshoreAssetTabLoading";
    this.setUserStoreData(loader, true);
    this.setUserStoreData(apiList, deafaultOffshoreApiStatus);
    this.updateUserStoreData(apiList, {
      getSettingsData: "success",
      getLiasionData: "success",
      getConnectData: "success",
      getProfile: "success",
      getFamilyData: "success",
      getPortfolioReturnData: "success",
      getPortfolioData: "success",
    });

    // Fetch currency data first
    // If currency fetch succeeds then call other APIs of required data
    // Else do not call other APIs and display error screen
    this._getUsersCurrency({
      params: resourceId,
      signal,
      onSuccess: (data) => {
        this.setUserStoreData(
          "currencyData",
          dataIsArray(data) ? getUniqueCurrencies({ data }) : [],
        );

        const currency = data[0]?.currency;

        this.setUserStoreData("selectedCurrency", { currency });

        const endpointData = {
          resourceApiPrefix,
          currency,
          signal,
          apiList,
          loader,
        };

        this.getOffshorePortfolioReturn(endpointData);
        // this.getOffshorePortfolio(endpointData);
        this.getOffshorePortfolioAssetClasses(endpointData);
        this.getOffshoreSubAssetClasses(endpointData);
        this.getOffshoreReturnsLine(endpointData);

        // if (this.getData === "fam") {
        //   // only in case of family level
        //   this._getUsersFamilyView({
        //     user_id: userId,
        //     currency,
        //     advisor: this.getDataWithNuvamaOrOther,
        //     onSuccess: (data) => {
        //       this.addToOffshoreData({
        //         familyViewData: this.setFamilyViewData(data),
        //       });
        //       this.addToOffshoreData({
        //         downloadFamilyViewFileData: this.familyViewData.map(
        //           this.getDataInExcelFormat,
        //         ),
        //       });
        //       // this.familyViewData = this.setFamilyViewData(data);
        //       // this.excelAssetDataFamily = this.familyViewData.map(
        //       //   this.getDataInExcelFormat
        //       // );

        //       this.setOffshoreApiStatus({
        //         apiList,
        //         currentApi: "getFamilyView",
        //         apiStatus: "success",
        //         loader,
        //       });
        //     },
        //     onFail: (error) => {
        //       this.setOffshoreApiStatus({
        //         apiList,
        //         currentApi: "getFamilyView",
        //         apiStatus: "failed",
        //         loader,
        //       });
        //     },
        //     signal: signal,
        //   });
        // } else {
        //   this.setOffshoreApiStatus({
        //     apiList,
        //     currentApi: "getFamilyView",
        //     apiStatus: "success",
        //     loader,
        //   });
        // }

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getFamilyView",
          apiStatus: "success",
          loader,
        });

        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersCurrency",
          apiStatus: "success",
          loader,
        });
      },
      onFail: (error) => {
        this.setUserStoreData("currencyData", []);

        this.setUserStoreData("offshoreSubAssetPageTabs", []);
        this.setOffshoreApiStatus({
          apiList,
          currentApi: "getUsersCurrency",
          apiStatus: "failed",
          loader,
        });
        this.setUserStoreData(loader, false);
      },
    });
  }

  populateOffshoreDataSubAssetPage(params) {
    const {
      currency,
      assetClassId,
      vehicleId,
      signal,
      offshoreTabsData,
      onSuccess: onCurrencySuccess,
    } = params;

    const loader = "isFullPageLoaderOffshoreSubAsset";

    this.setUserStoreData(loader, true);

    this.setUserStoreData(
      "offshoreSubAssetApiFetchStatus",
      pendingOffshoreSubAssetApiStatus,
    );

    this.addToOffshoreData({
      structuredData: {},
    });

    if (!offshoreTabsData.length || !currency) {
      const { resourceId } = getUserDataForAPIs({
        userData: this.userData,
        getData: this.getData,
      });

      // Fetch the currencies which are availables at the selected client/ family

      this._getUsersCurrency({
        params: {
          ...resourceId,
        },
        signal,
        onSuccess: (data) => {
          const offshoreTabs = getAssetsClassTabsData({ data });

          function getClass({ data, id, dataId }) {
            const firstData = data[0];

            if (!id) {
              return firstData;
            } else {
              return (
                data?.find((tabData) => tabData[dataId] == id) || firstData
              );
            }
          }

          // assetClassId and vehicleId can be null when this function is called for member change
          // So if these ids are null or data is not present for the selected id then consider first data from the array else consider available data
          const assetClass = getClass({
            data: offshoreTabs,
            id: assetClassId,
            dataId: "assetId",
          });

          const subAssetClass = getClass({
            data: assetClass.allSubAssetDetails,
            id: vehicleId,
            dataId: "id",
          });

          const currency = subAssetClass?.currency;

          // Set selected global instrument first and then set global/offshore datas structure data
          // And using these data set tabs, sub tabs , currency and currency list in OffshoreDataSubAssetPage
          this.setUserStoreData("selectedOffshoreInstrument", {
            assetClassId: assetClass.assetId,
            vehicleId: subAssetClass.id,
            subAssetClassName: subAssetClass.subAssetName,
          });

          // this.setUserStoreData(
          //   "currencyData",
          //   dataIsArray(data) ? getUniqueCurrencies({ data }) : [],
          // );

          this.addToOffshoreData({
            offshoreTabsData: offshoreTabs,
          });

          const structuredData = getOffshoreSubAssetDataStructure({
            offshoreTabs,
          });

          this.addToOffshoreData({
            structuredData,
          });

          this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
            ...this.offshoreSubAssetApiFetchStatus,
            currency: "success",
          });

          this.setUserStoreData("isCurrencyDataLoading", false);

          onCurrencySuccess({ data: currency });

          this.getOffshoreInvestmentDetails({
            loader,
            currency,
            assetClassId: assetClass.assetId,
            vehicleId: subAssetClass.id,
            subAssetClassName: subAssetClass.subAssetName,
            signal,
          });
          this.getOffshoreInstrumentVehicleData({
            assetClassId: assetClass.assetId,
            vehicleId: subAssetClass.id,
            signal,
            currency,
            loader,
          });
        },
        onFail: (error) => {
          if (error.code !== "ERR_CANCELED") {
            this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
              assetClass: "failed",
              currency: "failed",
              instruments: "failed",
            });
            this.setUserStoreData(loader, false);
            this.setUserStoreData("isCurrencyDataLoading", false);
          }
        },
      });
    } else {
      this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
        ...this.offshoreSubAssetApiFetchStatus,
        currency: "success",
      });
      // OffshoreTabsData and structuredData contains only those asset class , sub asset class and currencies , which have isHolding flag as true
      // So in case if given asset class and sub asset class ids are not present in this data with isHolding true then consider first available asset class and its first sub asset class
      this.addToOffshoreData({ offshoreTabsData });

      const structuredData = getOffshoreSubAssetDataStructure({
        offshoreTabs: offshoreTabsData,
      });

      let ids = {};

      if (!structuredData[assetClassId]) {
        ids.assetClassId = Object.keys(structuredData)[0];
        ids.vehicleId = Object.keys(
          structuredData[ids.assetClassId].allSubAssetDetails,
        )[0];
      } else {
        const subAssetClassDetails =
          structuredData[assetClassId].allSubAssetDetails;
        ids.assetClassId = assetClassId;
        ids.vehicleId = subAssetClassDetails[vehicleId]
          ? vehicleId
          : Object.keys(subAssetClassDetails)[0];
      }

      const currencyWiseData =
        structuredData[ids.assetClassId].allSubAssetDetails[ids.vehicleId]
          .currencyWiseData;
      const availableCurrency = currencyWiseData[currency]
        ? currency
        : Object.keys(currencyWiseData)[0];

      const subAssetClassName =
        structuredData[ids.assetClassId]?.allSubAssetDetails?.[ids.vehicleId]
          ?.currencyWiseData[availableCurrency]?.subAssetClass;

      // Set selected global instrument first and then set global/offshore datas structure data
      // And using these data set tabs, sub tabs , currency and currency list in OffshoreDataSubAssetPage
      this.setUserStoreData("selectedOffshoreInstrument", {
        assetClassId: ids.assetClassId,
        vehicleId: ids.vehicleId,
        subAssetClassName,
      });

      this.addToOffshoreData({
        structuredData,
      });

      onCurrencySuccess({ availableCurrency });

      // Get investment return and instrument list
      this.getOffshoreGridAndTableData({
        assetClassId: ids.assetClassId,
        vehicleId: ids.vehicleId,
        currency,
        signal,
        assetClassLoader: loader,
        tableLoader: loader,
        subAssetClassName,
      });
    }
  }

  getOffshoreTransactions({
    instrumentId,
    measureinstrumentid,
    currency,
    signal,
    onSuccess,
    onFail,
  }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    const params = {
      apiPreFix: resourceApi.resourceApiPrefix,
      isInfinity: this.isInfinity,
      advisor: this.getDataWithNuvamaOrOther,
      instrumentId,
      measureinstrumentid,
      IsOffshore: true,
      currency,
    };

    this._getUsersTransactions({
      ...params,
      signal,
      onSuccess: (data) => {
        const transactions = {
          ...this.offshoreInstrumentTransactions,
          transaction: data,
        };
        this.setUserStoreData("offshoreInstrumentTransactions", transactions);
        onSuccess(transactions);
      },
      onFail: (error) => {
        onFail();
      },
    });
  }

  getOffshoreInvestmentDetails({
    loader,
    assetClassId,
    vehicleId,
    subAssetClassName,
    ...params
  }) {
    const { resourceId } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    this._getUsersInvestmentDetailsOffshore({
      ...resourceId,
      subAssetClassId: vehicleId,
      assetClassId,
      ...params,
      onSuccess: (data) => {
        const vehicleData = {
          ...getOffshoreInvestmentReturn({ data }),
          assetClass: {
            name: subAssetClassName,
          },
        };

        this.setUserStoreData("selectedOffshoreInstrument", {
          ...this.selectedOffshoreInstrument,
          // assetClassId: rowData.id,
          // vehicleId: vehiclList.id,
          assetClassData: {
            id: assetClassId,
          },
          vehicleData,
        });

        // Save vehicleData in respective asset class and its sub asset class
        this.addToOffshoreData({
          structuredData: updateCurrencyData({
            structuredData: this.offshoreData.structuredData,
            assetClassId,
            vehicleId,
            currency: params.currency,
            data: {
              assetClassData: {
                id: assetClassId,
              },
              vehicleData,
            },
          }),
        });

        this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
          ...this.offshoreSubAssetApiFetchStatus,
          assetClass: "success",
        });
        this.checkOffshoreSubAssetApiStatus({
          loader,
          currentDataPoint: "isAssetClassTabLoading",
        });
        this.setUserStoreData("isAssetClassTabLoading", false);
      },

      onFail: (error) => {
        if (error.code !== "ERR_CANCELED") {
          this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
            ...this.offshoreSubAssetApiFetchStatus,
            assetClass: "failed",
          });
          this.checkOffshoreSubAssetApiStatus({
            loader,
            currentDataPoint: "isAssetClassTabLoading",
          });
          this.setUserStoreData("isAssetClassTabLoading", false);
        }
      },
    });
  }

  populateSubAssetPage({ path, ...rest }) {
    switch (path) {
      case OFFSHORE_SUB_ASSET_PAGE:
        //  this.populateOffshoreSubAssetPage({ path, ...rest });
        this.populateOffshoreDataSubAssetPage({ path, ...rest });
        break;
      default:
    }
  }

  getOffshoreInstrumentVehicleData({
    assetClassId,
    vehicleId,
    currency,
    signal,
    loader,
    //measureId,
  }) {
    const { resourceApi } = getUserDataForAPIs({
      userData: this.userData,
      getData: this.getData,
    });

    this._getUsersInstrumentReturns({
      apiPreFix: resourceApi.resourceApiPrefix,
      advisor: this.getDataWithNuvamaOrOther,
      isInfinity: this.isInfinity,
      isLive: this.isLive,
      IsOffshore: true,
      assetClassId,
      vehicleId,
      currency,
      signal,
      onSuccess: (data) => {
        let modifiedLocalData = data
          .map((vehicle) => {
            return returnModifiedData(vehicle);
          })
          .filter((eachData) => eachData);

        this.setUserStoreData("selectedOffshoreInstrument", {
          ...this.selectedOffshoreInstrument,
          modifiedVehicleData: modifiedLocalData,
        });

        // Save modifiedLocalData in respective asset class and its sub asset class
        this.addToOffshoreData({
          structuredData: updateCurrencyData({
            structuredData: this.offshoreData.structuredData,
            assetClassId,
            vehicleId,
            currency,
            data: {
              modifiedVehicleData: modifiedLocalData,
            },
          }),
        });

        this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
          ...this.offshoreSubAssetApiFetchStatus,
          instruments: "success",
        });
        this.checkOffshoreSubAssetApiStatus({
          loader,
          currentDataPoint: "isInstrumentsDataLoading",
        });
        this.setUserStoreData("isInstrumentsDataLoading", false);
      },
      onFail: () => {
        if (error.code !== "ERR_CANCELED") {
          this.setUserStoreData("offshoreSubAssetApiFetchStatus", {
            ...this.offshoreSubAssetApiFetchStatus,
            instruments: "failed",
          });
          this.checkOffshoreSubAssetApiStatus({
            loader,
            currentDataPoint: "isInstrumentsDataLoading",
          });
          this.setUserStoreData("isInstrumentsDataLoading", false);
        }
      },
      // MeasureInstrumentId: measureId,
    });
  }

  getOffshoreGridAndTableData({ assetClassLoader, tableLoader, ...params }) {
    if (assetClassLoader) {
      this.setUserStoreData(assetClassLoader, true);
      this.getOffshoreInvestmentDetails({
        ...params,
        loader: assetClassLoader,
      });
    }
    if (tableLoader) {
      this.setUserStoreData(tableLoader, true);
      this.getOffshoreInstrumentVehicleData({ ...params, loader: tableLoader });
    }
  }

  setOffShoreAssetDataToDefault() {
    this.currencyData = [];
    this.offshoreData = {};
    this.selectedOffshoreInstrument = { vehicleId: null, assetClassId: null };
    this.updatedOffshoreInstruments = [];
    this.subAssetCurrencyData = [];
    this.offshoreInstrumentTransactions = {};
    this.offshoreSubAssetPageTabs = [];
  }

  updateHomeLoading(isLoading) {
    this.homeLoad = isLoading;
  }

  setCurrentFamMembersOrImages(key, data) {
    this[key] = data;
  }
  setCurrenMembersImages() {
    this.currentFamilyMembersImages = ProfileStore2.currentFamilyMembersImages;
  }

  populateHomeScreen() {
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    this.homeLoad = true;
    this.HomePageApiStatus = {
      connectApi: "pending",
      familyPortfolio: "pending",
      familyPortfolioReturn: "pending",
      familyRecentTransaction: "pending",
      familyCorporateActions: "pending",
      familyMemberAccessData: null,
      profileData: "pending",
    };
    const familyId = this.userData.family_id || getCookie("famid");
    const userId = this.userData.user_id || getCookie("userid");

    this.portfolio?.clientPortfolio?.valuation?.advisorHoldingsList?.find(
      (item) => item.advisor_type === "heldaway",
    );

    this.setConnectData([]);
    // this.setPagesApiStatus("HomePageApiStatus", "connectApi", "failed");
    this.getPointOfConnect({
      onSuccess: (data) => {
        this.setConnectData(data);
        this.setPagesApiStatus("HomePageApiStatus", "connectApi", "success");
        this.exportDetails = data;
      },
      onFail: (error) => {
        this.setConnectData([]);
        this.setPagesApiStatus("HomePageApiStatus", "connectApi", "failed");
      },
    });

    if (this.getData === "fam") {
      PerformanceStore.setLoaderStatus("homeFamPortfolio", "pending");
      this._getFamilyPortfolio({
        userId: familyId,
        onSuccess: (data) => {
          this.addToPortfolio({ clientPortfolio: data });
          this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
          this.setIsUserLoggedIn(true);
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyPortfolio",
            "success",
          );
          PerformanceStore.setLoaderStatus("homeFamPortfolio", "success");
          PerformanceStore.loaderCloseFunction();
        },
        onFail: (err) => {
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyPortfolio",
            "failed",
          );
          PerformanceStore.setLoaderStatus("homeFamPortfolio", "failure");
          PerformanceStore.loaderCloseOnFail();
        },
      });
      PerformanceStore.setLoaderStatus("homeFamPortfolioReturn", "pending");
      this._getFamilyPortfolioReturn({
        userId: familyId,
        onSuccess: (data) => {
          this.addToPortfolio({ clientPortfolioReturn: data });
          this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyPortfolioReturn",
            "success",
          );
          PerformanceStore.setLoaderStatus("homeFamPortfolioReturn", "success");
          PerformanceStore.loaderCloseFunction();
        },
        onFail: (err) => {
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyPortfolioReturn",
            "failed",
          );
          PerformanceStore.setLoaderStatus("homeFamPortfolioReturn", "failure");
          PerformanceStore.loaderCloseOnFail();
        },
      });
      PerformanceStore.setLoaderStatus("homeFamTransaction", "pending");
      this._getFamilyRecentTransaction({
        userId: familyId,
        onSuccess: (data) => {
          // AuthStore.updateLoadingFullScreen(false);
          this.addToPortfolio({ clientRecentTransactions: data });
          this.setHomeNoDataCondition(data?.clientTransactions);
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyRecentTransaction",
            "success",
          );
          PerformanceStore.setLoaderStatus("homeFamTransaction", "success");
          PerformanceStore.loaderCloseFunction();
        },
        onFail: (err) => {
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyRecentTransaction",
            "failed",
          );
          PerformanceStore.setLoaderStatus("homeFamTransaction", "failure");
          PerformanceStore.loaderCloseOnFail();
        },
      });
      PerformanceStore.setLoaderStatus("homeFamCorporate", "pending");
      this._getFamilyCorporateActions({
        userId: familyId,
        onSuccess: (data) => {
          this.addToPortfolio({ clientCorporateActions: data });
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyCorporateActions",
            "success",
          );
          PerformanceStore.setLoaderStatus("homeFamCorporate", "success");
          PerformanceStore.loaderCloseFunction();
        },
        onFail: (err) => {
          this.setPagesApiStatus(
            "HomePageApiStatus",
            "familyCorporateActions",
            "failed",
          );
          PerformanceStore.setLoaderStatus("homeFamCorporate", "failure");
          PerformanceStore.loaderCloseOnFail();
        },
      });
      PerformanceStore.setLoaderStatus("carousalStatus", "pending");
      this.getCorouselData();
      const { user_type } = getDecodedToken();
      if (user_type === "customer") {
        this.HomePageApiStatus.familyMemberAccessData = "pending";
        SettingsStore.callGetFamilyMemberAccessData({
          onDataSuccess: (data) => {
            this.setPagesApiStatus(
              "HomePageApiStatus",
              "familyMemberAccessData",
              "success",
            );
            PerformanceStore.setLoaderStatus(
              "familyMemberAccessData",
              "success",
            );
            PerformanceStore.loaderCloseFunction();
          },
          onDataFail: (error) => {
            this.setPagesApiStatus(
              "HomePageApiStatus",
              "familyMemberAccessData",
              "failed",
            );
            PerformanceStore.setLoaderStatus(
              "familyMemberAccessData",
              "failure",
            );
            PerformanceStore.loaderCloseOnFail();
          },
        });
      } else {
        SettingsStore.updateSettingsOptionsArr(
          settingsMenuDetails.filter((eachMenuDetail) => {
            return eachMenuDetail?.accessibleBy?.includes(user_type);
          }),
        );
      }
      ReportsStore.getprofile({ userId });
      return;
    }

    const { user_type, primary } = getDecodedToken();
    SettingsStore.updateSettingsOptionsArr(
      settingsMenuDetails.filter((eachMenuDetail) => {
        if (
          (eachMenuDetail.key === "family_member_access" &&
            primary === "false") ||
          (eachMenuDetail.key === "liaison_office_access" &&
            primary === "false")
        ) {
          return false;
        }
        return eachMenuDetail?.accessibleBy?.includes(user_type);
      }),
    );
    PerformanceStore.setLoaderStatus("homeFamPortfolio", "pending");
    this._getClientPortfolio({
      userId,
      onSuccess: (data) => {
        this.setIsUserLoggedIn(true);
        this.addToPortfolio({ clientPortfolio: data });
        this.setInfinityDataReport(data?.valuation?.infinity?.total_amount);
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyPortfolio",
          "success",
        );
        PerformanceStore.setLoaderStatus("homeFamPortfolio", "success");
        PerformanceStore.loaderCloseFunction();
      },
      onFail: (err) => {
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyPortfolio",
          "failed",
        );
        PerformanceStore.setLoaderStatus("homeFamPortfolio", "failure");
        PerformanceStore.loaderCloseOnFail();
      },
    });
    PerformanceStore.setLoaderStatus("homeFamPortfolioReturn", "pending");
    this._getClientPortfolioReturn({
      userId,
      onSuccess: (data) => {
        this.addToPortfolio({ clientPortfolioReturn: data });
        this.setAsOfDate(data?.as_of_date, data?.unrealised_gain);
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyPortfolioReturn",
          "success",
        );
        PerformanceStore.setLoaderStatus("homeFamPortfolioReturn", "success");
        PerformanceStore.loaderCloseFunction();
      },
      onFail: (err) => {
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyPortfolioReturn",
          "failed",
        );
        PerformanceStore.setLoaderStatus("homeFamPortfolioReturn", "failure");
        PerformanceStore.loaderCloseOnFail();
      },
    });
    PerformanceStore.setLoaderStatus("homeFamTransaction", "pending");
    this._getClientRecentTransaction({
      userId,
      onSuccess: (data) => {
        this.addToPortfolio({ clientRecentTransactions: data });
        this.setHomeNoDataCondition(data?.clientTransactions);
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyRecentTransaction",
          "success",
        );
        PerformanceStore.setLoaderStatus("homeFamTransaction", "success");
        PerformanceStore.loaderCloseFunction();
      },
      onFail: (err) => {
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyRecentTransaction",
          "failed",
        );
        PerformanceStore.setLoaderStatus("homeFamTransaction", "failure");
        PerformanceStore.loaderCloseOnFail();
      },
    });
    PerformanceStore.setLoaderStatus("homeFamCorporate", "pending");
    this._getClientCorporateActions({
      userId,
      onSuccess: (data) => {
        this.addToPortfolio({ clientCorporateActions: data });
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyCorporateActions",
          "success",
        );
        PerformanceStore.setLoaderStatus("homeFamCorporate", "success");
        PerformanceStore.loaderCloseFunction();
      },
      onFail: (err) => {
        this.setPagesApiStatus(
          "HomePageApiStatus",
          "familyCorporateActions",
          "failed",
        );
        PerformanceStore.setLoaderStatus("homeFamCorporate", "failure");
        PerformanceStore.loaderCloseOnFail();
      },
    });
    PerformanceStore.setLoaderStatus("carousalStatus", "pending");
    this.getCorouselData();
    ReportsStore.getprofile({ userId });
    if (user_type === "manager") {
      SettingsStore.getLaisonOfficersData({
        clientId: userId,
        onSuccess: (data) => {
          const imageArr = {};
          if (data[0].profile.profile_pic) {
            SettingsStore.getImageFromAPI({
              path: data[0].profile.profile_pic,
              onSuccess: (imageRawData) => {
                getBlobToBase64(imageRawData).then((url) => {
                  let resImage = url;
                  imageArr[data[0].profile.user_id] = resImage;
                  SettingsStore.profile = {
                    name: data[0].profile.profile_pic.slice(
                      data[0].profile.profile_pic.lastIndexOf("/") + 1,
                    ),
                    size: getFileSize(imageRawData?.size),
                    exactSize: imageRawData?.size,
                    type: imageRawData?.type,
                    src: resImage,
                    file: imageRawData,
                  };
                  SettingsStore.liaisonOfficerImages = {
                    ...SettingsStore.liaisonOfficerImages,
                    ...imageArr,
                  };
                });
              },
            });
          }
          SettingsStore.liaisonOfficerData = data[0];
        },
        loader: true,
      });
    }

    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
  }

  getLiaisonsData() {
    const userId = this.userData.user_id || getCookie("userid");
    SettingsStore.getLaisonOfficersData({
      clientId: userId,
      onSuccess: (data) => {
        const imageArr = {};
        if (data[0].profile.profile_pic) {
          SettingsStore.getImageFromAPI({
            path: data[0].profile.profile_pic,
            onSuccess: (imageRawData) => {
              getBlobToBase64(imageRawData).then((url) => {
                let resImage = url;
                imageArr[data[0].profile.user_id] = resImage;
                SettingsStore.profile = {
                  name: data[0].profile.profile_pic.slice(
                    data[0].profile.profile_pic.lastIndexOf("/") + 1,
                  ),
                  size: getFileSize(imageRawData?.size),
                  exactSize: imageRawData?.size,
                  type: imageRawData?.type,
                  src: resImage,
                  file: imageRawData,
                };
                SettingsStore.liaisonOfficerImages = {
                  ...SettingsStore.liaisonOfficerImages,
                  ...imageArr,
                };
              });
            },
            loader: false,
          });
        } else {
          imageArr[data[0].profile.user_id] = null;
          SettingsStore.liaisonOfficerImages = {
            ...SettingsStore.liaisonOfficerImages,
            ...imageArr,
          };
        }
        SettingsStore.liaisonOfficerData = data[0];
      },
      loader: false,
    });
  }

  setSessionId(id) {
    this.sessionId = id;
    setCookie("sessionid", id);
  }

  setIsPrimary(primary) {
    this.isPrimary = primary;
  }
  setUserDataEmpty() {
    this.userData = {};
  }

  checkNonPrimaryUser(isHeldaway) {
    if (isHeldaway) {
      this.withNuvama = true;
      this.withOthers = true;
      setCookie("withNuvama", "1");
      setCookie("withOthers", "1");
      this.getDataWithNuvamaOrOther = "all";
    } else {
      this.withNuvama = true;
      this.withOthers = false;
      setCookie("withNuvama", "1");
      setCookie("withOthers", "0");
      this.getDataWithNuvamaOrOther = "edelweiss";
    }
  }

  setUserData(data, data2) {
    const tokenData = getDecodedToken();
    if (tokenData?.user_type === "manager") {
      this.checkNonPrimaryUser(data.isheldaway);
    } else if (tokenData?.user_type === "employee") {
      if (this.getData === "fam") {
        this.checkNonPrimaryUser(data.isheldawayfamily);
      }
      // if user is non-primary
      else this.checkNonPrimaryUser(data.isheldaway);
    } else {
      if (
        data.isheldaway ||
        (data.isprimary && data.isheldawayfamily && !data.memberSwitched)
      ) {
        switch (data.investmentHeldWith || "1") {
          case "0":
            this.withNuvama = true;
            this.withOthers = true;
            setCookie("withNuvama", "1");
            setCookie("withOthers", "1");
            this.getDataWithNuvamaOrOther = "all";
            break;
          case "1":
            this.withNuvama = true;
            this.withOthers = false;
            setCookie("withNuvama", "1");
            setCookie("withOthers", "0");
            this.getDataWithNuvamaOrOther = "edelweiss";
            break;
          case "2":
            this.withNuvama = false;
            this.withOthers = true;
            setCookie("withNuvama", "0");
            setCookie("withOthers", "1");
            this.getDataWithNuvamaOrOther = "others";
            break;
          default:
        }
      } else {
        this.withNuvama = true;
        this.withOthers = false;
        setCookie("withNuvama", "1");
        setCookie("withOthers", "0");
        this.getDataWithNuvamaOrOther = "edelweiss";
      }
    }

    this.userData = { ...this.userData, ...data };
    if (data.user_id && data.family_id) {
      this.userId = data.user_id;
      this.familyId = data.family_id;
      setCookie("userid", data.user_id);
      setCookie("famid", data.family_id);
      setCookie("isPrimary", data.isprimary);
    }
    if (data2 === "whileLogginIn") {
      if (tokenData.user_type === "customer") {
        this.loggedInWithOthers = data.investmentHeldWith;
      }

      this.isSelectedUserPrimary = data.isprimary;
      this.selectedUsersId = data.user_id;
      setCookie("isSelectedUserPrimary", data.isprimary);
      setCookie("selectedUsersId", data.user_id);
    }
  }

  getLiasionDetailsAndImage() {
    const user_id = this.userData.user_id;
    const loId = this.userData?.liasonOfficers?.[0]?.liasonOfficerId;

    liaisonDetails({ user_id, loId })
      .then(({ data }) => {
        if (data.profile_pic) {
          ProfileStore2.getImage(data.profile_pic, "liaison");
        }
      })
      .catch((error) => {});
  }

  setIsSalesForceLogin(data) {
    this.isSalesForceLogin = data;
  }

  setToInitialStateOnSwich() {
    this.changeIsLiveToZero("0", false);
    this.setInfinity("0");
    this.setNormalHybirdFlow(false);
  }

  setUserStoreToIntialState() {
    this.asOfDate = null;
    this.usersData = "";
    this.unrealisedData = null;
    this.infinityData = null;
    this.homeRecentTransactionLength = null;
    this.isSalesForceLogin = false;
    this.isUserLoggedIn = false;
    this.employeeFamilies = null;
    this.isNoDataSubAssetLevel = false;
    this.isNoAssetClassPresent = false;
    this.vehicleDataLength = null;
    this.sessionId = undefined;
    this.linkedClients = undefined;
    this.usersFamilyName = "";
    this.userData = { allMembers: true };
    this.data = "";
    this.portfolio = {};
    this.familyId = "";
    this.userId = "";
    this.getData = "fam";
    this.connectData = [];
    this.userDeviceId = "";
    this.selectedContact = undefined;
    this.rememberedMeasureId = "";
    this.loggedInWithOthers = undefined;
    this.withNuvama = getCookie("withNuvama") === "1";
    this.withOthers = getCookie("withOthers") === "1";
    this.withNuvamaState = getCookie("withNuvamaState") === "1";
    this.withOthersState = getCookie("withOthersState") === "1";
    this.useNuvamaFilter = getCookie("usernuvamafilter") === "1";
    this.vehicleInstrumentData = {};
    this.getDataWithNuvamaOrOther = "";
    this.singleUsersUrl = "";
    this.isNavigated = false;
    this.transectionReportFilter = {
      timePeriod: "current_month",
      transectionType: ["BOUGHT", "SOLD", "BONUS", "SPLIT"],
      upcomingtransectionType: ["SIP", "STP", "SWP", "DRAWDOWN", "MATURITY"],
      selectedMember: "All",
      selectedAssetClass: "All",
      selectedAccount: "All",
      selectedAcquisitionDate: "",
    };
    this.portfolioReportFilter = {
      timePeriod: "current_month",
      denomination: {},
      selectedMember: "All",
      selectedAccount: "All",
      selectedAcquisitionDate: "Transfer-In Date",
      selectedSection: [1, 3],
    };
    this.transectionCorporateActionReportFilter = {
      timePeriod: "current_fy",
      transectionType: "interest",
      selectedMember: "All",
      selectedAssetClass: "All",
    };
    this.liaisonImage = "";
    this.getDataWithNuvamaOrOtherState = "";
    this.currentFamilyMembers = undefined;
    this.currentFamilyMembersImages = null;
    this.realEstateImage = null;
    this.selectedInstrumentVehicle = undefined;
    this.instrumentDetails = undefined;
    this.constUserId = this.userData?.user_id || getCookie("userid");
    this.constFamilyId = this.userData?.family_id || getCookie("famid");
    this.quickViewDetails = undefined;
    this.derivativesDetails = [];
    this.realEstateData = undefined;
    this.isInfinity = "0";
    this.portfolioPath = [];
    this.analyticsPath = [];
    this.isPrimary = true;
    this.isLive = "0";
    this.toggleLive = false;
    this.connectImages = {};
    this.selectedMemberIsPrimary = true;
    this.infinityMesurementId = "";
    this.forThirdLevelMeasureId = "";
    this.infinityPortfolioReturns = undefined;
    this.excelAssetClassesData = undefined;
    this.excelAssetClassesDataInfinity = undefined;
    this.excelAssetDataFamily = undefined;
    this.exportDetails = undefined;
    this.selectedClientId = "0";
    this.homeLoad = false;
    this.selectedPortfoliotab = "financial";
    this.selectedAnalyticsTab = "Overall";
    this.clientQuickviews = null;
    this.isHybridNormalInstrument = false;
    this.infinityHoldingData = null;
    this.nonInfinitySubAssetData = null;
    this.selectedRefId = "";
    this.forReportsInceptionDate = "";
    this.selectedRefIdInfinity = "";
    this.selectedRefIdSub = "";
    this.isSelectedUserPrimary = null;
    this.selectedUsersId = null;
    this.othersInfinityHolding = {
      clientcode: "1",
      id: 100,
      assetClass: {
        clientcode: "1",
        id: 0,
        name: "Others",
        defaultIndex: {
          clientcode: "",
          id: 0,
          name: "",
        },
      },
      allocation_percentage: "0",
      investmentreturn: {
        clientcode: "1",
        as_of_date: "",
        current_value: {
          actual_value: "",
          value: "",
          value_type: "",
        },
        total_returns: {
          actual_value: "",
          value: "",
          value_type: "",
        },
        irr: "0.00",
        invested_value: {
          actual_value: "",
          value: "",
          value_type: "",
        },
        int_div: {
          amount: {
            actual_value: "",
            value: "",
            value_type: "",
          },
          percentage: "",
        },
        unrealised_gain: {
          amount: {
            actual_value: "",
            value: "",
            value_type: "",
          },
          percentage: "",
        },
        realised_Gains: {
          amount: {
            actual_value: "",
            value: "",
            value_type: "",
          },
          percentage: "",
        },
        measureinstrumentid: "",
        commitment_val: "",
        maturity_Date: "",
      },
      instrumentVehiclesList: [],
    };
    this.fromHome = false;
    this.fromPortfolio = false;
    this.fromPerformance = false;
    this.modifiedData = [];
    this.portfolioReportObj = {};
    this.portfolioReportFileName = "";
    this.selectedAccount = {};
    this.taxFromDate = {};
    this.taxToDate = {};
    this.taxPdfDownloadFromDate = "";
    this.taxPdfDownloadToDate = "";
    this.emailIdDataForTax = {};
    this.isTaxSendEmail = "";

    this.selectedUserForEmail = "";
    this.selectedUserForName = "";
    this.rememberedModifiedData = [];
    this.modifiedInfinityData = [];
    this.rememberedInfinityData = [];
    this.lstInstrumentReturnsFromHome = [];
    this.totalCurrentValueFromHome = {
      actual_value: "",
      value: "",
      value_type: "",
    };
    this.selectedInstrumentVehicleInfinity = undefined;
    this.reportsFirstState = "";
    this.portfolioTabsStatus = {
      financial: false,
      liabilities: false,
      derivatives: false,
      realEstate: false,
      offshore: false,
    };

    this.callingSubAssetApi = false;

    this.callingLiveApi = {
      tileDataLoading: false,
      tableDataLoading: false,
    };
    this.subAssetFirstVehicleListIds = {
      assetId: null,
      subAssetId: null,
    };
    this.familyViewData = [];
    this.selectedInfinityInstrument = {
      assetClassId: null,
      vehicleId: null,
    };
    this.financialApiStatus = {
      familyPortfolioReturn: null,
      familyPortfolio: null,
      assetClass: null,
      subAssetClass: null,
      returnsLine: null,
      QuickViews: null,
    };
    this.HomePageApiStatus = {
      connectApi: null,
      familyPortfolio: null,
      familyPortfolioReturn: null,
      familyRecentTransaction: null,
      familyCorporateActions: null,
      familyMemberAccessData: null,
      profileData: null,
    };
    this.snippets = { ...snippetDefaultData };
    this.offshoreApiStatus = {};
    this.offshoreTabApiStatus = {};
    this.memberChangeOffshoreApiStatus = {};

    this.offshoreData = {};
    this.currencyData = [];
    this.selectedOffshoreInstrument = { vehicleId: null, assetClassId: null };
    // this.firstSubAssetOffshoreIds = {
    //   assetId: null,
    //   subAssetId: null,
    // };
    this.updatedOffshoreInstruments = [];
    this.subAssetCurrencyData = [];
    this.offshoreInstrumentTransactions = {};
    this.isOffshoreAssetPageLoading = false;
    this.isOffshoreAssetTabLoading = false;
    this.isOffshoreAssetDataLoading = false;
    this.isFullPageLoaderOffshoreSubAsset = false;
    this.isAssetClassTabLoading = false;
    this.isCurrencyDataLoading = false;
    this.isInstrumentsDataLoading = false;
    this.offshoreSubAssetApiFetchStatus = defaultOffshoreSubAssetApiStatus;
    this.selectedCurrency = {
      currency: "",
    };
    this.offshoreSubAssetPageTabs = [];
    this.secondaryRMDetails = defaultSecondaryRMData;
  }
  uploadProfile(file, { onSucess, onFail }) {
    uploadProfileHook(file)
      .then(({ data }) => {
        onSucess(data);
      })
      .catch((data) => {
        onFail(data);
      });
  }

  setLinkedClients = (clients) => {
    if (clients) {
      this.linkedClients = [...clients];
    }
  };

  getImageFromAPI({ path, onSuccess, onFail }) {
    plainApiClient
      .get(path, { responseType: "blob" })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  }

  getPointOfConnect = ({ onFail, onSuccess }) => {
    pointOfConnect(this.userData.user_id || getCookie("userid"))
      .then(({ data }) => {
        onSuccess(data);
        data.forEach(({ id, profilePic, ...dataItem }) => {
          if (!profilePic) return;
          this.getImageFromAPI({
            path: profilePic,
            onSuccess: (imageBlob) => {
              getBlobToBase64(imageBlob).then((url) => {
                let resImage = url;
                this.connectImages = { ...this.connectImages, [id]: resImage };
              });
            },
            onFail: () => {
              this.connectImages = { ...this.connectImages, [id]: "" };
            },
          });
        });
      })
      .catch((error) => {
        onFail(error);
      });
  };

  getSecondaryRMDetails = ({ onFail, onSuccess }) => {
    getSecondaryRm(this.userData.user_id || getCookie("userid"))
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  };

  _postFeedback = (payload, { onFail, onSuccess }) => {
    const tokenData = getDecodedToken();
    let userType = "";
    let userName = "";
    if (tokenData?.user_type === "employee") {
      userType = "Employee";
      userName = tokenData.full_name;
    }
    if (tokenData?.user_type === "customer") {
      userName = tokenData.full_name;
      userType = "Client";
    }
    if (tokenData?.user_type === "manager") {
      userName = tokenData.full_name;
      userType = "Liaison Officer";
    }
    postFeedback({
      id: this.userData.user_id || getCookie("userid"),
      UserType: userType,
      username: userName,
      ...payload,
    })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        onFail(error);
      });
  };

  _getLiaisionLinkedClients = ({ onSuccess, onFail }) => {
    getLinkedClients()
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch(({ response: { data } }) => {
        onFail(data);
      });
  };

  callInfinityHolding(measureId, infinity) {
    this.getInfinityReturns(measureId, infinity);
  }

  get isHydrated() {
    return isHydrated(this);
  }

  onHeaderPortfolioClick() {
    this.changeIsLiveToZero("0", false);
    this.setNormalHybirdFlow(false);
    this.removeInfinity();
    PerformanceStore.setCurrentLoader("fullScreen");
    window.scrollTo(0, 0);
    AuthStore.updateLoadingFullScreen(true);
    this.setSelectedTab("Financial Assets");
    this.populatePortfolio();
    this.getQuickViews();
    if (getDecodedToken()?.user_type !== "manager") {
      this.getFamilyClients("forImg");
    }
  }
}

const User = new UserStore();

export default User;
